<template>
  <div>
    <ParentBar />
    <PermissionValidation :marketId="marketId" rule="enableViewAppeal">
      <div class="headline">
        <div class="headline-text">
          {{ $t('appeal_data.notify') }}
        </div>
        <div class="headline-filter">
          <div class="filter-box me-3">
            <div class="filter-group">
              <div class="filter">
                <v-menu v-model="menu" :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="filter-select d-flex align-center pa-4" v-bind="attrs" v-on="on">
                      <div class="filter-select-text">{{ getSelectedFilterText }}</div>
                      <div class="filter-select-count" v-if="!filterSelecter.includes('all') && filterSelecter.length">
                        ({{ filterSelecter.length }})</div>
                    </div>
                  </template>
                  <v-card>
                    <v-list>
                      <v-list-item class="filter-checkbox-item">
                        <v-checkbox v-model="filterSelecter" :value="'all'" :label="$t('all_appeals')"
                          @change="onChangeFilter()" hide-details class="filter-checkbox"></v-checkbox>
                      </v-list-item>
                      <v-list-item class="filter-checkbox-item" v-for="item in filterItem" :key="item.value">
                        <v-checkbox v-model="filterSelecter" :value="item.value"
                          :label="$t(`appeal_data.category.${item.value}`)" @change="onChangeFilter()" hide-details
                          class="filter-checkbox"></v-checkbox>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </div>
          </div>
          <v-btn color="info" @click="openAppeal('create')">
            <v-icon left>mdi-plus-box</v-icon>{{ $t('appeal.create_appeal') }}
          </v-btn>
        </div>
      </div>
      <div class="container-appeal">
        <div class="text-center p-10" v-if="isLoading && isFristTime">
          <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
        </div>
        <div v-if="!isFristTime">
          <div class="container-appeal-status">
            <AppealStatusCard :status="`waiting`" :appeals="filterAppeals(getAppealsWaiting)" @openAppeal="openAppeal"
              :isFiltering="isFiltering" />
            <AppealStatusCard :status="`pending`" :appeals="filterAppeals(getAppealsPending)" @openAppeal="openAppeal"
              :isFiltering="isFiltering" />
            <AppealStatusCard :status="`approved`" :appeals="filterAppeals(getAppealsApproved)" @openAppeal="openAppeal"
              :isFiltering="isFiltering" />
            <AppealStatusCard :status="`success`" :appeals="filterAppeals(getAppealsSuccess)" @openAppeal="openAppeal"
              @loadMoreDataSuccess="loadMoreDataSuccess" :loading="loadingMoreDataSuccess"
              :isMoreData="isMoreDataSuccess" :isHideLoadMore="isHideLoadMoreSuccess" :isFiltering="isFiltering" />
            <AppealStatusCard :status="`cancelled`" :appeals="filterAppeals(getAppealsCancelled)"
              @openAppeal="openAppeal" @loadMoreDataCancelled="loadMoreDataCancelled"
              :loading="loadingMoreDataCancelled" :isMoreData="isMoreDataCancelled"
              :isHideLoadMore="isHideLoadMoreCancelled" :isFiltering="isFiltering" />
          </div>
        </div>
      </div>

      <template>
        <v-row justify="center">
          <v-dialog v-model="isAppeal" max-width="900" scrollable persistent content-class="dialog-appeal">
            <v-card outlined>
              <v-form v-if="isAppeal && !isLoadAppeal"
                @submit.prevent="mode == 'create' ? createAppeal() : updateAppeal()" ref="form">
                <v-card-title v-if="AppealLabels.status[form.status]"
                  :class="`flex justify-between ${form.status ? AppealLabels.status[form.status].colorBg : ''}`">
                  <div>
                    {{
                      mode == 'create'
                        ? $t('appeal.create_appeal')
                        : mode == 'update'
                          ? `${isView ? '' : $t('action_type.edit')}${$t('appeal_data.title')} ${form.subCategory &&
                            AppealLabels.subCategory[form.subCategory] ?
                            ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) : ''}`
                          : mode == 'cancelled'
                            ? $t('appeal.appeal_cancelled')
                            : "-"
                    }}
                  </div>
                  <div style="display: flex; align-items: center;">
                    <v-chip color="warning" v-if="form.requestData.statusBeforeCancelled == 'success'"
                      style="margin-right:5px;">{{ $t('task.appeal_approved_before') }}</v-chip>
                    <v-tooltip top v-if="AppealLabels.status[form.status]">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-chip v-show="mode != 'create'" :color="AppealLabels.status[form.status].color">
                            <span style="color:#FFF">{{
                              $t(`appeal_data.status.${AppealLabels.status[form.status].value}.text`) }}</span>
                          </v-chip>
                        </div>
                      </template>
                      <div>{{ $t(`appeal_data.status.${AppealLabels.status[form.status].value}.tooltip`) }}</div>
                    </v-tooltip>
                  </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="dialog-appeal-in overflow-y-auto">
                  <v-container>
                    <v-select v-model="form.category"
                      :items="mode == 'create' ? categoryItem.filter(s => !s.isHidden) : categoryItem" item-text="text"
                      item-value="value" :label="$t('appeal.select_appeal_category')" outlined required
                      :rules="rules.select2" @change="selectCategory" :disabled="isView || mode == 'update'"
                      :no-data-text="$t('noinfo')">
                      <template v-slot:item="{ item }">
                        {{ $t(`appeal_data.category.${item.value}`) }}
                      </template>
                      <template v-slot:selection="{ item }">
                        {{ $t(`appeal_data.category.${item.value}`) }}
                      </template>
                    </v-select>
                    <v-select :disabled="!form.category || form.category == 'all' || isView || mode == 'update'"
                      v-model="form.subCategory" :items="subCategoryItem" item-text="text" item-value="value"
                      :label="$t('appeal.select_appeal')" outlined required :rules="rules.select2"
                      :no-data-text="$t('noinfo')">
                      <template v-slot:item="{ item }">
                        {{ $t(`appeal_data.subCategory.${item.value}`) }}
                      </template>
                      <template v-slot:selection="{ item }">
                        {{ $t(`appeal_data.subCategory.${item.value}`) }}
                      </template>
                    </v-select>

                    <template v-if="form.category && form.subCategory">
                      <template v-if="form.subCategory == 'document_shop_certify'">
                        <v-select v-model="form.requestData.reasonShopCertify" :items="reasonShopCertifyItem"
                          item-text="text" item-value="value" :label="$t('customer.reason_for_document')" outlined
                          required :rules="rules.select2" :disabled="isView" :no-data-text="$t('noinfo')">
                          <template v-slot:item="{ item }">
                            {{ $t(`appeal_data.reasonShopCertifyItem.${item.value}`) }}
                          </template>
                          <template v-slot:selection="{ item }">
                            {{ $t(`appeal_data.reasonShopCertifyItem.${item.value}`) }}
                          </template>
                        </v-select>
                        <span>{{ $t('market.start_date_business_with_market') }}</span>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                          :return-value.sync="form.requestData.startDateCertify" transition="scale-transition" offset-y
                          min-width="auto" :disabled="isView">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field solo flat background-color="grey lighten-4"
                              :value="$helper.datelabel(form.requestData.startDateCertify)"
                              :label="$t('market.start_date_business_with_market')" prepend-inner-icon="mdi-calendar"
                              readonly v-bind="attrs" v-on="on" :disabled="isView"></v-text-field>
                          </template>
                          <v-date-picker v-model="form.requestData.startDateCertify" no-title scrollable locale="th"
                            :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                            persistent-hint :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                            :disabled="isView">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="menu1 = false">{{ $t('cancel') }}</v-btn>
                            <v-btn text color="success" @click="$refs.menu1.save(form.requestData.startDateCertify)">{{
                              $t('confirm')
                            }}</v-btn>
                          </v-date-picker>
                        </v-menu>

                        <span v-if="form.documentRunningNumber && false">{{ $t('customer.document_number') }}</span>
                        <v-text-field v-if="form.documentRunningNumber && false" flat background-color="grey lighten-4"
                          solo :disabled="true" :value="shopCertifyNo(form)"></v-text-field>
                      </template>
                      <div v-if="form.subCategory == 'suspend_other'">
                        <span>{{ $t('suspend.input_title_business_suspend') }}</span>
                        <v-text-field v-model="form.requestData.otherType" solo flat background-color="grey lighten-4"
                          :label="$t('suspend.input_title_business_suspend')" :rules="rules.select"
                          :disabled="isView" />
                      </div>
                      <div class="col-span-3" v-if="form.status == 'cancelled'">
                        <span class="mb-2">
                          {{ $t('customer.reason_for') }}
                          <v-chip color="error" style="margin-right:5px;">{{ $t('cancel') }}</v-chip>
                          <v-chip color="warning" v-if="form.requestData.statusBeforeCancelled == 'success'">{{
                            $t('task.appeal_approved_before') }}</v-chip>
                        </span>
                        <v-text-field flat background-color="grey lighten-4" solo
                          :label="$t('market.reason_for_cancel')" v-model="form.updatedStatusNote" required
                          :rules="rules.select" :disabled="isView"></v-text-field>
                      </div>
                      <div class="flex justify-between">
                        <h4>{{ $t('appeal.appeal_reporter') }}</h4>
                      </div>

                      <template>
                        <v-radio-group v-model="customerType" row hide-details class="mt-2 mb-3"
                          @change="onCustomerTypeChange">
                          <div class="d-flex justify-between align-center gap-2 w-100">
                            <div class="w-50">
                              <v-radio :label="$t('appeal.customer')" value="customer" class="box-radio"
                                :disabled="isView || mode == 'update' || !AppealLabels.subCategory[form.subCategory].isEnableCustomerType"></v-radio>
                            </div>
                            <div class="w-50">
                              <template v-if="!AppealLabels.subCategory[form.subCategory].isEnableCustomerType">
                                <v-tooltip top content-class="bg-grey white--text">
                                  <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                      <v-radio :label="$t('appeal.central')" value="central" class="box-radio"
                                        :disabled="isView || mode == 'update' || !AppealLabels.subCategory[form.subCategory].isEnableCustomerType"></v-radio>
                                    </div>
                                  </template>
                                  <span>{{ $t('appeal.central_cannot_appeal') }}</span>
                                </v-tooltip>
                              </template>
                              <template v-else>
                                <v-radio :label="$t('appeal.central')" value="central" class="box-radio"
                                  :disabled="isView || mode == 'update' || !AppealLabels.subCategory[form.subCategory].isEnableCustomerType"></v-radio>
                              </template>
                            </div>
                          </div>
                        </v-radio-group>
                      </template>

                      <template v-if="customerType == 'customer'">
                        <div class="d-flex justify-between align-center my-3">
                          <v-alert colored-border border="left" color="warning" class="alert-warning-appeal w-100 mb-0">
                            {{ $t('appeal.please_select_market_to_appeal') }}
                          </v-alert>
                          <v-btn color="success" text @click="searchDialog = true"
                            :disabled="!form.subCategory || isView || mode == 'update'">
                            <v-icon left size="16">mdi-magnify</v-icon>{{ $t('customer.search_customer') }}
                          </v-btn>
                        </div>
                        <customer-card v-if="form.customer" :emails="form.customer.emails"
                          :firstName="form.customer.firstName" :lastName="form.customer.lastName"
                          :tels="form.customer.tels" :interTels="form.customer.interTels"
                          :companyName="form.customer.companyName" :type="form.customer.type"
                          :img="form.customer.profileImages && form.customer.profileImages[0] ? form.customer.profileImages[0].url : '/user.png'"
                          :url="`/project/${projectId}/market/${marketId}/customer/${form.customer.objectId}/view`"></customer-card>
                        <template v-else>
                          <v-btn class="customer-box" text @click="searchDialog = true"
                            :disabled="!form.subCategory || isView || mode == 'update'">
                            <div style="display:block;">
                              <div>{{ $t('appeal.select_appeal_reporter') }}</div>
                              <div class="color-red" v-if="!isView && form.subCategory">{{
                                $t('validate.required_select') }}</div>
                            </div>
                          </v-btn>
                          <v-text-field :disabled="isView" v-show="false" v-model="form.customer" required
                            :rules="rules.select3"></v-text-field>
                        </template>
                      </template>

                      <v-progress-linear indeterminate color="green"
                        v-if="isLoadAreas && form.subCategory != 'change_info_contact'"></v-progress-linear>

                      <AutocompleteArea
                        v-if="AppealLabels.subCategory[form.subCategory].isEnableArea || (form.subCategory == 'other' && customerType == 'central')"
                        v-model="form.areas" :items="currentAreas"
                        :label="`${$t('area.select_stall')} (${filterContractBySelectArea.length})`" outlined chips
                        :multiple="true" :item-text="i => i.text" :item-value="i => i.objectId"
                        :no-data-text="$t('appeal.no_stall_please_select_appeal_reporter')"
                        :required="customerType == 'customer'" :rules="customerType == 'customer' ? rules.select2 : []"
                        :disabled="(customerType == 'customer' && !form.customer) || !form.subCategory || isView || form.subCategory == 'change_info_contact' || mode == 'update' || form.subCategory == 'change_owner_contact' || form.subCategory == 'installment_invoice'"
                        @input="changeAreas" />

                      <v-select
                        v-if="(form.customer && (form.subCategory == 'installment_invoice' || form.subCategory == 'other' || form.category == 'suspend'))"
                        v-model="form.contract" @change="selectContract" :items="uniqueCurrentContracts"
                        :label="$t('contract.select_contract')" outlined chips
                        :item-text="contract => `${contract.contractId} (${contract.businessName || '-'})`"
                        :item-value="contract => contract"
                        :no-data-text="$t('appeal.no_rental_agreement_please_select_appeal_reporter')" required
                        :rules="rules.select" :disabled="!form.subCategory || isView || mode == 'update'"></v-select>

                      <v-autocomplete v-if="form.customer && form.subCategory == 'other'" v-model="form.areas"
                        :items="contractAreas" :label="`${$t('market.select_stall_if_have')}`" outlined chips
                        :multiple="true" :item-text="i => i.name" :item-value="i => i.objectId"
                        :no-data-text="$t('appeal.no_stall_please_select_appeal_reporter')" :disabled="isView"
                        @input="changeAreas" clearable>
                        <template v-slot:selection="{ props, item, index }">
                          <v-chip v-bind="props" :close="!isView" @click:close="form.areas.splice(index, 1)"
                            :disabled="isView">
                            {{ item.name }}
                          </v-chip>
                        </template>
                      </v-autocomplete>

                      <template v-if="form.customer && AppealLabels.subCategory[form.subCategory].isEnableContract">
                        <v-select v-model="form.contract" :items="currentContracts"
                          :item-text="contract => `${contract.contractId} ${!contract.isActive ? `(${$t('contract.close_contract')})` : ''}`"
                          :item-value="contract => contract" :label="$t('contract.select_contract')"
                          :no-data-text="$t('area.no_rental_agreement')" outlined required :rules="rules.select"
                          :disabled="isView || mode == 'update'">
                          <template v-slot:selection="{ item }">
                            <div class="d-block w-100" style="width: 100%">
                              {{ `${item.contractId}` }}
                              <span class="rounded-full text-white bg-red-500 px-2 py-1 text-xs ml-2"
                                v-if="!item.isActive">{{ $t('contract.close_contract') }}</span>
                            </div>
                          </template>
                        </v-select>
                        <div class="change-old-box">
                          <span>{{ $t('customer.transferor_name') }}</span>
                          <div class="text-lg grey lighten-4">{{ form.customer && form.customer.type == 'company' ?
                            `${form.customer.companyName}` : `${form.customer.title} ${form.customer.firstName}
                            ${form.customer.lastName}` }}</div>
                        </div>
                        <span>{{ $t('customer.receiver_name') }}</span>
                        <span class="color-red" v-if="!form.requestData.contractNewCustomer">{{
                          $t('validate.required_select') }}</span>
                        <div class="change-box" style="display: flex; justify-content: flex-end;">
                          <customer-card v-if="form.requestData.contractNewCustomer"
                            :emails="form.requestData.contractNewCustomer.emails"
                            :firstName="form.requestData.contractNewCustomer.firstName"
                            :lastName="form.requestData.contractNewCustomer.lastName"
                            :tels="form.requestData.contractNewCustomer.tels"
                            :interTels="form.requestData.contractNewCustomer.interTels"
                            :companyName="form.requestData.contractNewCustomer.companyName"
                            :type="form.requestData.contractNewCustomer.type"
                            :img="form.requestData.contractNewCustomer.profileImages && form.requestData.contractNewCustomer.profileImages[0] ? form.requestData.contractNewCustomer.profileImages[0].url : '/user.png'"
                            :url="`/project/${projectId}/market/${marketId}/customer/${form.requestData.contractNewCustomer.objectId}/view`"></customer-card>
                          <v-btn color="success" @click="getCustomers()" style="margin-left:5px;" :disabled="isView">
                            <v-icon left>{{ form.requestData.contractNewCustomer ? 'mdi-pencil' : 'mdi-plus-box'
                            }}</v-icon>
                            {{ form.requestData.contractNewCustomer ? $t('customer.change_receiver_name') :
                              $t('customer.add_receiver_name')
                            }}
                          </v-btn>
                          <v-text-field :disabled="isView" v-show="false" v-model="form.requestData.contractNewCustomer"
                            required :rules="rules.select3"></v-text-field>
                        </div>

                        <span>{{ $t('companion_party') }}</span>
                        <v-combobox :disabled="isView" flat background-color="grey lighten-4" solo
                          v-model="form.requestData.relation" :items="relationsLabel"
                          :label="$t('customer.select_relation')" :rules="rules.select" required>
                          <template v-slot:selection="{ item }">
                            {{ $t(`appeal_data.relations.${item}`) }}
                          </template>
                          <template v-slot:item="{ item }">
                            {{ $t(`appeal_data.relations.${item}`) }}
                          </template>
                        </v-combobox>
                        <span>{{ $t('contract.transfer_effective_date') }}</span>
                        <v-chip color="success"
                          v-if="form.status == 'success' && form.subCategory == 'change_owner_contact' && form.isEffective"
                          style="margin-left:5px;">{{ $t('customer.transfer_success') }}</v-chip>
                        <v-chip color="warning"
                          v-if="form.status == 'success' && form.subCategory == 'change_owner_contact' && !form.isEffective"
                          style="margin-left:5px;">{{ $t('contract.waiting_transfer') }}</v-chip>
                        <v-radio-group v-model="form.effectiveByStatus" @change="changeEffectiveDate($event)"
                          style="margin-top:0;">
                          <v-radio :disabled="isView || form.isEffective" :value="true" color="info"
                            :label="$t('contract.effective_date_now')"></v-radio>
                          <v-radio :disabled="isView || form.isEffective" :value="false" color="info"
                            :label="$t('contract.effective_date_selected')"></v-radio>
                        </v-radio-group>
                        <v-menu v-if="!form.effectiveByStatus" ref="menu_effective_date" v-model="menuEffectiveDate"
                          :close-on-content-click="false" :return-value.sync="form.effectiveDate_tmp"
                          transition="scale-transition" offset-y min-width="auto"
                          :disabled="isView || form.isEffective">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field solo flat background-color="grey lighten-4"
                              :value="$helper.datelabel(form.effectiveDate_tmp)" :label="$t('customer.effective_date')"
                              prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                              :disabled="isView || form.isEffective"></v-text-field>
                          </template>
                          <v-date-picker v-model="form.effectiveDate_tmp" no-title scrollable locale="th"
                            :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                            :min="$moment().add(1, 'days').format('YYYY-MM-DD')" persistent-hint :disabled="isView"
                            :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="menuEffectiveDate = false">{{ $t('cancel') }}</v-btn>
                            <v-btn text color="success"
                              @click="$refs.menu_effective_date.save(form.effectiveDate_tmp)">{{ $t('confirm')
                              }}</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </template>

                      <div v-if="AppealLabels.subCategory[form.subCategory].isEnableInfo && form.customer">
                        <div class="change-old-box">
                          <span>
                            {{ form.customer.type == 'company' ? $t('customer.company_name_title') : $t('name_surname')
                            }}
                            <u>
                              <b>{{ $t('old') }}</b>
                            </u>
                          </span>
                          <div class="text-lg grey lighten-4">{{ form.customer.type == 'company' ?
                            form.requestData.oldCompanyName :
                            `${form.requestData.oldPrefixName}${form.requestData.oldFirstName}
                            ${form.requestData.oldLastName}` }}</div>
                        </div>
                        <span>
                          {{ form.customer.type == 'company' ? $t('customer.company_name_title') : $t('name_surname') }}
                          <u>
                            <b>{{ $t('new') }}</b>
                          </u>
                        </span>
                        <div class="change-box" v-if="form.customer.type == 'company'">
                          <span>{{ $t('customer.company_name_title') }}</span>
                          <v-text-field :disabled="isView" flat background-color="grey lighten-4" solo
                            :label="$t('customer.company_name_title')" v-model="form.requestData.companyName"
                            :rules="rules.select" required></v-text-field>
                        </div>
                        <div class="grid grid-cols-5 gap-2 change-box" v-else>
                          <div>
                            <span>{{ $t('account.prefix') }}</span>
                            <v-combobox :disabled="isView" flat background-color="grey lighten-4" solo
                              v-model="form.requestData.prefixName" :items="prefixName" :label="$t('account.prefix')"
                              :rules="rules.select" required>
                            </v-combobox>
                          </div>
                          <div class="col-span-2">
                            <span>{{ $t('account.first_name') }}</span>
                            <v-text-field :disabled="isView" flat background-color="grey lighten-4" solo
                              :label="$t('account.first_name')" v-model="form.requestData.firstName"
                              :rules="rules.select" required></v-text-field>
                          </div>
                          <div class="col-span-2">
                            <span>{{ $t('account.last_name') }}</span>
                            <v-text-field :disabled="isView" flat background-color="grey lighten-4" solo
                              :label="$t('account.last_name')" v-model="form.requestData.lastName" :rules="rules.select"
                              required></v-text-field>
                          </div>
                        </div>

                        <span>{{ form.customer.type == 'company' ? $t('customer.company_document') :
                          $t('customer.citizen_card_images')
                        }}</span>
                        <div class="change-box">
                          <div class="grid grid-cols-2 gap-2">
                            <div>
                              <span>
                                {{ form.customer.type == 'company' ? $t('customer.company_document') :
                                  $t('customer.citizen_card_images')
                                }}
                                <u>
                                  <b>{{ $t('old') }}</b>
                                </u>
                              </span>
                              <template v-if="form.requestData.oldCitizenCardImages">
                                <v-card outlined v-for="(citizen, index) of form.requestData.oldCitizenCardImages"
                                  :key="`citizenxx_${index}`" class="mb-2">
                                  <v-card-text class="relative" style="padding:0;">
                                    <div class="d-flex justify-space-between w-100 bg-gray-100">
                                      <img :src="citizen.url" style="width:auto;height:100px;margin:0 auto;" />
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </template>
                              <div v-else>{{ $t('not_specified') }}</div>
                            </div>
                            <div>
                              <div class="flex justify-between">
                                <div>
                                  {{ form.customer.type == 'company' ? $t('customer.company_document') :
                                    $t('customer.citizen_card_images') }}
                                  <u><b>{{ $t('new') }}</b></u>
                                </div>
                                <div id="error_upload_citizen_card" class="danger-file">{{
                                  $t('market.support_file_size') }} {{
                                    maxFileUploadText }}!</div>
                              </div>
                              <v-file-input :disabled="isView" ref="citizenImage" accept="image/*"
                                :label="form.customer.type == 'company' ? $t('customer.company_document') : $t('customer.citizen_card_images')"
                                @change="uploadFile($event, citizenCardImages_tmp, 'error_upload_citizen_card', 'citizen_card')"
                                flat background-color="grey lighten-4" solo clearable
                                @click:clear="removeImageUploadAll('citizen_card', 'error_upload_citizen_card')"></v-file-input>
                              <v-card outlined v-for="(citizen, index) of citizenCardImages_tmp"
                                :key="`citizenxx_${index}`" class="mb-2">
                                <v-card-text class="relative" style="padding:0;">
                                  <div class="d-flex justify-space-between bg-gray-100 w-100">
                                    <img :src="citizen.url" style="width:auto;height:100px;margin:0 auto;" />
                                    <v-btn class="absolute right-1 top-1" small elevation="0" color="error" icon
                                      :disabled="isView"
                                      @click="removeImageUpload(index, citizenCardImages_tmp, 'error_upload_citizen_card', 'citizen_card')">
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="AppealLabels.subCategory[form.subCategory].isEnableInstallment && form.customer && form.areas"
                        style="margin-bottom:20px;">
                        <v-select :label="$t('invoice.select_invoice_to_adjust')"
                          :no-data-text="$t('invoice.no_invoice_to_adjust')" outlined chips :items="invoiceContractItem"
                          :disabled="!invoiceContractItem || isView || mode == 'update'" item-value="objectId" required
                          :rules="rules.select3" v-model="form.requestData.installmentInvoice" @change="selectInvoice">
                          <template v-slot:selection="{ item }">
                            {{ `${item.documentId}` }}
                            ({{ `${item.documentTypeString}` }})
                            <div class="m-2">{{ $t('net_amount') }}</div>
                            <div class="text-xl">
                              {{ item.totalValue | currency }}
                              <span class="text-lg">{{ $helper.currencySign() }}</span>
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            {{ `${item.documentId}` }}
                            ({{ `${item.documentTypeString}` }})
                            <div class="m-2">{{ $t('net_amount') }}</div>
                            <div class="text-xl">
                              {{ item.totalValue | currency }}
                              <span class="text-lg">{{ $helper.currencySign() }}</span>
                            </div>
                          </template>
                        </v-select>

                        <v-select v-if="form.requestData.installmentInvoice"
                          :label="$t('invoice.select_installment_period')"
                          :no-data-text="$t('invoice.no_installment_period')" :items="installmentAmountItem"
                          :item-value="amount => amount" required :rules="rules.select"
                          v-model="form.requestData.installmentAmount" @change="selectInstallmentAmount" outlined
                          :disabled="isView || mode == 'update'">
                          <template v-slot:selection="{ item }">{{ `${$t('invoice.installment_period_message', {
                            installment: item
                          })}` }}</template>
                          <template v-slot:item="{ item }">{{ `${item} ${$t('invoice.installment_period')}`
                          }}</template>
                        </v-select>

                        <div v-if="form.requestData.installmentAmount">
                          <div class="flex justify-between">
                            <h3>{{ $t('invoice.installment_table') }}</h3>
                          </div>
                          <v-row>
                            <v-col cols="1" class="text-center">{{ $t('invoice.installment_period_at') }}</v-col>
                            <v-col cols="6" class="text-center">{{ $t('invoice.installment_due_date') }}</v-col>
                            <v-col cols="5" class="text-right">{{ $t('invoice.installment_total_amount') }} ({{
                              $helper.currencyThEn()
                            }})</v-col>
                          </v-row>
                          <v-row v-for="(item, index) in form.requestData.dataInstallmentTable" :key="index"
                            class="row-installment">
                            <v-col cols="1" class="text-center text-xl">{{ item.amount }}</v-col>
                            <v-col cols="6">
                              <v-menu ref="menu_due_date" v-model="item.isDateMenu" :close-on-content-click="false"
                                :return-value.sync="item.dueDate" transition="scale-transition" offset-y
                                min-width="auto" :disabled="isView || mode == 'update'">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field solo flat background-color="grey lighten-4"
                                    :value="$helper.datelabel(item.dueDate)" :label="$t('invoice.installment_due_date')"
                                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="item.dueDate" no-title scrollable locale="th"
                                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                                  :min="$moment().format('YYYY-MM-DD')" persistent-hint
                                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                                  <v-spacer></v-spacer>
                                  <v-btn text color="error" @click="item.isDateMenu = false">{{ $t('cancel') }}</v-btn>
                                  <v-btn text color="success" @click="$refs.menu_due_date[index].save(item.dueDate)">{{
                                    $t('confirm')
                                  }}</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="5">
                              <v-text-field type="Number" flat background-color="grey lighten-4" solo
                                :label="$t('payment.amount')" v-model="item.totalValue" class="input-right"
                                :disabled="isView || mode == 'update'"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="sumInstallment().isPass">
                            <v-col class="text-right text-red-400">
                              <div class="text-xl">
                                {{ sumInstallment().text }}
                                <span class="text-lg">{{ $helper.currencySign() }}</span>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </div>

                      <div v-if="AppealLabels.subCategory[form.subCategory].isEnableProduct && form.areas.length > 0"
                        class="product-in-areas-box-list">
                        <div class="product-in-areas-box-header">{{ $t('product.product_list') }}</div>
                        <div class="product-in-areas-box">
                          <div v-for="(currentAreaObject, areaObjectIndex) in form.requestData.areaProducts"
                            :key="currentAreaObject.objectId" class="product-in-areas-items">
                            <div class="product-in-areas-item-header text-gray-400">
                              {{ $t('product.product_to_sell_in_market', { count: currentAreaObject.name }) }}
                              <u>
                                <b>{{ $t('old') }}</b>
                              </u>
                            </div>
                            <v-chip disabled v-for="product of currentAreaObject.products" class="m-1"
                              :key="`old-${currentAreaObject.objectId}-${product.objectId}`">{{ product.name }}</v-chip>
                            <div class="no-data" v-if="currentAreaObject.products.length == 0">{{
                              $t('product.no_product_in_market') }}
                            </div>
                            <div class="product-in-areas-item-header">
                              {{ $t('product.product_to_sell_in_market', { count: currentAreaObject.name }) }}
                              <u>
                                <b>{{ $t('new') }}</b>
                              </u>
                            </div>
                            <div class="flex justify-space-between">
                              <div v-if="currentAreaObject.newProducts && currentAreaObject.newProducts.length">
                                <v-chip v-for="(product, productIndex) in currentAreaObject.newProducts"
                                  :key="'product-' + productIndex" class="m-1">{{ product.name }}</v-chip>
                              </div>
                              <div v-else class="no-data">{{ $t('validate.please_add_product_to_sell') }}</div>
                              <v-btn color="info" @click="clickAddProduct(currentAreaObject, areaObjectIndex)"
                                elevation="0" :disabled="isView || isLoading">
                                <v-icon left>mdi-plus</v-icon>
                                {{ currentAreaObject.newProducts && currentAreaObject.newProducts.length ?
                                  $t('action_type.edit') :
                                  $t('action_type.add') }}{{ $t('product.product_in_sell') }}
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>

                      <template
                        v-if="mode != 'create' && AppealLabels.subCategory[form.subCategory].isEnableContract && form.subCategory != 'renew_contract'">
                        <div class="flex justify-between">
                          <h3>{{ $t('invoice.title') }}</h3>
                        </div>
                        <div>
                          <div class="change-box" style="text-align: end;">
                            <v-btn :color="true ? 'success' : 'gray'" @click="createInvoice(null)"
                              :disabled="isInvoiceDialog || !form.customer || isLoading || form.status == 'success' || mode == 'cancelled'">
                              <v-icon left>mdi-plus-box</v-icon>{{ $t('invoice.title') }}
                            </v-btn>

                            <div v-for="(invoice, index) in form.invoices" :key="index">
                              <v-card class="invoice-card">
                                <v-card-text class="flex justify-between">
                                  <div>
                                    <b>{{ $t('invoice.invoice_other_bill') }} {{ invoice.totalValue |
                                      currencySuffixTextThEn }}</b>
                                    <v-chip style="margin-left:10px;" class="red--text" color="rgb(248,218,218)"
                                      v-if="statusInvoice(invoice) == $t('payment.pending')">{{ statusInvoice(invoice)
                                      }}</v-chip>
                                    <v-chip style="margin-left:10px;" class="grey--text" color="rgb(240,242,246)"
                                      v-if="statusInvoice(invoice) == $t('payment.wait_approval')">{{
                                        statusInvoice(invoice) }}</v-chip>
                                    <v-chip style="margin-left:10px;" class="green--text" color="rgb(209,242,225)"
                                      v-if="statusInvoice(invoice) == $t('payment.already_paid')">{{
                                        statusInvoice(invoice) }}</v-chip>
                                    <v-chip style="margin-left:10px;" class="orange--text" color="rgb(241,151,50,0.2)"
                                      v-if="statusInvoice(invoice) == $t('bill.edit_bill')">{{ statusInvoice(invoice)
                                      }}</v-chip>
                                  </div>
                                  <v-btn class="py-2 text-white rounded-full" elevation="0" color="grey lighten-4"
                                    rounded @click="openInvoice(null, invoice.objectId)">{{ $t('detail') }}</v-btn>
                                </v-card-text>
                              </v-card>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="mode != 'create' && form.subCategory != 'renew_contract'">
                        <div class="flex justify-between"
                          v-if="form.contracts && form.contracts.length && filterContractBySelectArea.length">
                          <h3>{{ $t('invoice.title') }}</h3>
                        </div>
                        <div v-for="(contract, index) in filterContractBySelectArea" :key="index">
                          <span>{{ $t('contract.invoice_in_contract_at', { count: contract.contractId }) }}</span>
                          <div class="change-box" style="text-align: end;">
                            <v-btn :color="true ? 'success' : 'gray'" @click="createInvoice(contract)"
                              :disabled="isInvoiceDialog || isLoading || form.status == 'success' || mode == 'cancelled'">
                              <v-icon left>mdi-plus-box</v-icon>{{ $t('invoice.title') }}
                            </v-btn>
                            <div v-for="(invoice, index) in form.invoices" :key="index">
                              <v-card v-if="invoice.contract.objectId == contract.objectId" class="invoice-card">
                                <v-card-text class="flex justify-between">
                                  <div>
                                    <b>{{ $t('invoice.invoice_other_bill') }} {{ invoice.totalValue |
                                      currencySuffixTextThEn }}</b>
                                    <v-chip style="margin-left:10px;" class="red--text" color="rgb(248,218,218)"
                                      v-if="statusInvoice(invoice) == $t('payment.pending')">{{ statusInvoice(invoice)
                                      }}</v-chip>
                                    <v-chip style="margin-left:10px;" class="grey--text" color="rgb(240,242,246)"
                                      v-if="statusInvoice(invoice) == $t('payment.wait_approval')">{{
                                        statusInvoice(invoice) }}</v-chip>
                                    <v-chip style="margin-left:10px;" class="green--text" color="rgb(209,242,225)"
                                      v-if="statusInvoice(invoice) == $t('payment.already_paid')">{{
                                        statusInvoice(invoice) }}</v-chip>
                                    <v-chip style="margin-left:10px;" class="orange--text" color="rgb(241,151,50,0.2)"
                                      v-if="statusInvoice(invoice) == $t('bill.edit_bill')">{{ statusInvoice(invoice)
                                      }}</v-chip>
                                  </div>
                                  <v-btn class="py-2 text-white rounded-full" elevation="0" color="grey lighten-4"
                                    rounded @click="openInvoice(contract, invoice.objectId)">{{ $t('detail') }}</v-btn>
                                </v-card-text>
                              </v-card>
                            </div>
                          </div>
                        </div>
                      </template>

                      <template v-if="form.subCategory == 'renew_contract'">
                        <div v-if="form.renewOldContract"
                          :class="`renew-contract-box ${form.isEffective || !form.renewNewContract ? 'new-now' : ''}`">
                          <div class="col-1 sub-title">
                            <div class="mr-2">{{ $t('contract.rental_contract') }}</div>
                            <v-chip color="success">
                              <span>{{ $t('in_use') }}</span>
                            </v-chip>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.contract_id') }}</span>
                            <div class="input-slot"> {{ form.renewOldContract.contractId }} </div>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.start_date') }}</span>
                            <div class="input-slot"> {{ form.renewOldContract.startDateFormat }} </div>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.end_date') }}</span>
                            <div class="input-slot"> {{ form.renewOldContract.endDateFormat }} </div>
                          </div>
                          <div class="col-1">
                            <CardContractDocument v-for="(doc, index) of form.renewOldContract.contractDocument"
                              :key="`doc_old_${index}`" :indexNumber="`${index + 1}`" :object="doc"
                              @onView="contractDocumentDialog(doc, form.renewOldContract.objectId)"
                              :isDisabled="true" />
                            <CardContractDocument v-if="form.renewOldContract.contractDocument.length < 1"
                              :isNull="true" />
                          </div>
                        </div>
                        <div v-if="form.renewNewContract"
                          :class="`renew-contract-box ${form.isEffective ? '' : 'new'}`">
                          <div class="col-1 sub-title">
                            <div class="mr-2">{{ $t('contract.rental_contract') }} <span v-if="form.isEffective"><u>{{
                              $t('old') }}</u></span> <span v-else><u>{{ $t('advance') }}</u></span></div>
                            <v-chip color="warning" v-if="!form.isEffective">
                              <span>{{ $t('contract.effective_date_at', {
                                date:
                                  form.renewOldContract.renewEffectiveDateFormat || '-'
                              }) }}</span>
                            </v-chip>

                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.advance_contract_id') }}</span>
                            <div class="input-slot"> {{ form.renewNewContract.contractId }} </div>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.start_date') }}</span>
                            <div class="input-slot"> {{ form.renewNewContract.startDateFormat }} </div>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.end_date') }}</span>
                            <div class="input-slot"> {{ form.renewNewContract.endDateFormat }} </div>
                          </div>
                          <div class="col-1">
                            <CardContractDocument v-for="(doc, index) of form.renewNewContract.contractDocument"
                              :key="`doc_new_${index}`" :indexNumber="`${index + 1}`" :object="doc"
                              @onView="contractDocumentDialog(doc, form.renewOldContract.objectId)"
                              :isDisabled="true" />
                            <CardContractDocument v-if="form.renewNewContract.contractDocument.length < 1"
                              :isNull="true" />
                          </div>
                        </div>
                        <div v-if="!form.renewNewContract" :class="`renew-contract-box`">
                          <div class="col-1 sub-title">
                            <div class="mr-2">{{ $t('contract.rental_contract') }} <u>{{ $t('draft') }}</u></div>
                            <v-chip color="warning" v-if="!form.isEffective">
                              <span>{{ $t('contract.effective_date_at', { date: form.renewEffectiveDateFormat || '-' })
                              }}</span>
                            </v-chip>

                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.advance_contract_id') }}</span>
                            <div class="input-slot"> - </div>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.start_date') }}</span>
                            <div class="input-slot"> {{ form.startDateFormat }} </div>
                          </div>
                          <div class="col-3">
                            <span>{{ $t('contract.end_date') }}</span>
                            <div class="input-slot"> {{ form.endDateFormat }} </div>
                          </div>
                          <div class="col-1">
                            <template v-if="form.documents && form.documents.length > 0">
                              <CardContractDocument v-for="(doc, index) of form.documents" :key="`doc_new_${index}`"
                                :indexNumber="`${index + 1}`" :object="doc"
                                @onView="tempContractsDocumentDialog(doc, true)" :isDisabled="true" />
                            </template>
                            <CardContractDocument v-else :isNull="true" />
                          </div>
                        </div>
                      </template>

                      <div v-if="form.subCategory && AppealLabels.subCategory[form.subCategory].isEnableSuspend">
                        <div class="mt-2">
                          <div>
                            <span>{{ $t('operation_date') }}</span>
                            <v-menu ref="issueDate" v-model="issueDatePicker" :close-on-content-click="false"
                              :return-value.sync="form.requestData.issueDate" transition="scale-transition" offset-y
                              min-width="auto" :disabled="isView">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field :disabled="isView" :value="$helper.datelabel(form.requestData.issueDate)"
                                  :label="$t('start_date')" prepend-inner-icon="mdi-calendar" readonly solo flat
                                  background-color="grey lighten-4" v-bind="attrs" v-on="on"
                                  hide-details></v-text-field>
                              </template>
                              <v-date-picker locale="th" v-model="form.requestData.issueDate" no-title
                                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                                scrollable :disabled="isView" :weekday-format="$helper.formatWeekday"
                                :month-format="$helper.formatMonth">
                                <v-spacer></v-spacer>
                                <v-btn text color="error" @click="issueDatePicker = false">{{ $t('cancel') }}</v-btn>
                                <v-btn text color="success"
                                  @click="$refs.issueDate.save(form.requestData.issueDate);">{{ $t('ok')
                                  }}</v-btn>
                              </v-date-picker>
                            </v-menu>
                          </div>
                          <!-- <span>พักแผงค้า/พักการขาย</span> -->
                          <div class="change-box mt-4">
                            <v-checkbox class="mt-0" :label="$t('suspend.suspend_stall')"
                              v-model="form.requestData.isSuspend" :disabled="isView" hide-details></v-checkbox>
                            <v-row class="px-0 mt-4" v-if="form.requestData.isSuspend">
                              <v-col cols="4" class="pt-0">
                                <span>{{ $t('start_date') }}</span>
                                <v-menu ref="startDate" v-model="startDatePicker" :close-on-content-click="false"
                                  :return-value.sync="form.requestData.startDate" transition="scale-transition" offset-y
                                  min-width="auto" :disabled="isView">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :disabled="isView"
                                      :value="$helper.datelabel(form.requestData.startDate)" :label="$t('start_date')"
                                      prepend-inner-icon="mdi-calendar" readonly solo flat
                                      background-color="grey lighten-4" v-bind="attrs" v-on="on"
                                      hide-details></v-text-field>
                                  </template>
                                  <v-date-picker locale="th" v-model="form.requestData.startDate" no-title
                                    :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                                    scrollable :disabled="isView" :weekday-format="$helper.formatWeekday"
                                    :month-format="$helper.formatMonth">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="error" @click="startDatePicker = false">{{ $t('cancel')
                                    }}</v-btn>
                                    <v-btn text color="success"
                                      @click="$refs.startDate.save(form.requestData.startDate); editEndDate()">{{
                                        $t('ok') }}</v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="4" class="pt-0">
                                <span>{{ $t('end_date') }}</span>
                                <v-menu ref="endDate" v-model="endDatePicker" :close-on-content-click="false"
                                  :return-value.sync="form.requestData.endDate" transition="scale-transition" offset-y
                                  min-width="auto" :disabled="isView">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :disabled="isView"
                                      :value="$helper.datelabel(form.requestData.endDate)" :label="$t('end_date')"
                                      readonly prepend-inner-icon="mdi-calendar" solo flat
                                      background-color="grey lighten-4" v-bind="attrs" v-on="on"
                                      hide-details></v-text-field>
                                  </template>
                                  <v-date-picker locale="th" v-model="form.requestData.endDate" no-title scrollable
                                    :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                                    :disabled="isView" :weekday-format="$helper.formatWeekday"
                                    :month-format="$helper.formatMonth">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="error" @click="endDatePicker = false">{{ $t('cancel') }}</v-btn>
                                    <v-btn text color="success"
                                      @click="$refs.endDate.save(form.requestData.endDate); editEndDate()">{{
                                        $t('ok') }}</v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="4" class="pt-6 d-flex align-center">
                                <v-text-field :rules="[rules.loanMin]" :disabled="isView"
                                  v-model="form.requestData.suspendDays" @input="editSuspendDays"
                                  :label="$t('duration_day')" outlined rounded dense background-color="grey lighten-4"
                                  :messages="dayMonthYearText()" />
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        <div>
                          <span>{{ $t('appeal.detail_optional') }}</span>
                          <div class="change-box">
                            <v-textarea auto-grow :disabled="isView" flat background-color="grey lighten-4" solo
                              v-model="form.requestData.detail" rows="2" hide-details></v-textarea>
                          </div>
                        </div>
                        <div>
                          <span>{{ $t('appeal.penalty_detail_optional') }}</span>
                          <div class="change-box">
                            <v-textarea auto-grow :disabled="isView" flat background-color="grey lighten-4" solo
                              v-model="form.requestData.penaltyDetail" rows="2" hide-details></v-textarea>
                          </div>
                        </div>
                      </div>
                      <div v-if="form.subCategory != 'renew_contract'">
                        <span>{{ $t('detail') }} ({{ $t('optional') }})</span>
                        <div class="change-box">
                          <v-textarea auto-grow :disabled="isView" flat background-color="grey lighten-4" solo
                            v-model="form.description" hide-details></v-textarea>
                        </div>
                      </div>
                      <div v-if="form.subCategory != 'renew_contract'">
                        <span>{{ $t('project.image_or_documentation_if_have') }}</span>
                        <div class="change-box">
                          <div id="error_upload_appeal_image" class="danger-file">{{ $t('market.support_file_size') }}
                            {{
                              maxFileUploadText }}!</div>
                          <v-file-input :disabled="isView" ref="appealImage"
                            accept="image/*, application/pdf, .doc, .docx, .xml, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            :label="$t('market.add_image_or_document')"
                            @change="uploadFile($event, images_tmp, 'error_upload_appeal_image', 'appeal_image')" flat
                            background-color="grey lighten-4" solo clearable
                            @click:clear="removeImageUploadAll('appeal_image', 'error_upload_appeal_image')"></v-file-input>
                          <!-- v-model="requestData.images" -->
                          <div class="grid grid-cols-2 gap-2">
                            <v-card v-for="(appealImage, index) of images_tmp" :key="`appealxx_${index}`" flat outlined>
                              <v-card-text class="relative" style="padding:0;">
                                <div class="d-flex justify-space-between w-100 bg-gray-100"
                                  :id="`image-upload-images_tmp-${index}`">
                                  <img @error="imageError(`image-upload-images_tmp-${index}`)" :src="appealImage.url"
                                    style="height:100px;width:auto;margin:0 auto;" />
                                  <div class="absolute grid right-1 top-1">
                                    <v-btn :disabled="isView" small elevation="0" color="error" icon
                                      @click="removeImageUpload(index, images_tmp, 'error_upload_appeal_image', 'appeal_image')">
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-btn color="info" :disabled="!isView" small elevation="0" target="_blank"
                                      :href="appealImage.url" icon>
                                      <v-icon>mdi-download-circle-outline</v-icon>
                                    </v-btn>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                      <div v-if="mode != 'create'">
                        <v-card flat outlined>
                          <v-card-text>
                            <div class="flex justify-between my-2">
                              <span class="flex items-center gap-2">
                                <img src="@/assets/icons/appeal_status_icon_red.svg" v-if="form.status == 'cancelled'">
                                <img src="@/assets/icons/appeal_status_icon_green.svg" v-else>
                                <b>{{ fullName(form.createdBy) }}</b> {{ $t('appeal.create_appeal_status') }}
                              </span>
                              <span>{{ momentToDate(form.createdAt) }}</span>
                            </div>

                            <div class="flex justify-between my-2"
                              v-if="form.statusPendingAt && momentToDate(form.statusPendingAt, 'datetimesec') != momentToDate(form.statusApprovedAt, 'datetimesec')">
                              <span class="flex items-center gap-2">
                                <img src="@/assets/icons/appeal_status_icon_red.svg" v-if="form.status == 'cancelled'">
                                <img src="@/assets/icons/appeal_status_icon_green.svg" v-else>
                                <b>{{ fullName(form.statusPendingBy) }}</b> {{ $t('sent_appeal_at') }}
                              </span>
                              <span>{{ momentToDate(form.statusPendingAt) }}</span>
                            </div>

                            <!-- <div class="flex justify-between my-2" v-if="form.statusPendingBy && momentToDate(form.statusPendingAt, 'datetimesec') != momentToDate(form.statusApprovedAt, 'datetimesec')">
                              <span class="flex items-center gap-2">
                                <img src="@/assets/icons/appeal_status_icon_red.svg" v-if="form.status == 'cancelled'">
                                <img src="@/assets/icons/appeal_status_icon_green.svg" v-else>
                                <b>{{ fullName(form.statusPendingBy) }}</b> {{ $t('sent_by') }}
                              </span>
                              <span>{{ momentToDate(form.statusPendingAt) }}</span>
                            </div> -->

                            <div v-if="form.updatedAt && form.updatedBy">
                              <div class="flex justify-between my-2">
                                <span class="flex items-center gap-2">
                                  <img src="@/assets/icons/appeal_status_icon_red.svg"
                                    v-if="form.status == 'cancelled'">
                                  <img src="@/assets/icons/appeal_status_icon_green.svg" v-else>
                                  <b>{{ fullName(form.updatedBy) }}</b> {{ $t('appeal.update_appeal_status') }}
                                </span>
                                <span>{{ momentToDate(form.updatedAt) }}</span>
                              </div>
                            </div>
                            <div v-if="form.statusApprovedAt && form.statusApprovedBy">
                              <div class="flex justify-between my-2">
                                <span class="flex items-center gap-2">
                                  <img src="@/assets/icons/appeal_status_icon_red.svg"
                                    v-if="form.status == 'cancelled'">
                                  <img src="@/assets/icons/appeal_status_icon_green.svg" v-else>
                                  <b>{{ fullName(form.statusApprovedBy) }}</b> {{ $t('appeal.approve_appeal_status') }}
                                </span>
                                <span>{{ momentToDate(form.statusApprovedAt) }}</span>
                              </div>
                            </div>
                            <div v-if="form.statusSuccessAt && form.statusSuccessBy">
                              <v-divider class="my-2"></v-divider>
                              <div class="flex justify-between">
                                <span class="flex items-center gap-2">
                                  <img src="@/assets/icons/appeal_status_icon_green.svg">
                                  <span class="text-green-500"> <b>{{ fullName(form.statusSuccessBy) }}</b> &nbsp;{{
                                    $t('appeal.finish_appeal_status_date') }}</span>
                                </span>
                                <span class="text-green-500">{{ momentToDate(form.statusSuccessAt) }}</span>
                              </div>
                            </div>
                            <div v-if="form.statusCancelledAt && form.statusCancelledBy">
                              <v-divider class="my-2"></v-divider>
                              <div class="flex justify-between">
                                <span class="flex items-center gap-2">
                                  <img src="@/assets/icons/appeal_status_icon_red.svg">
                                  <span class="text-red-500"><b>{{ fullName(form.statusCancelledBy) }}</b> &nbsp;{{
                                    $t('appeal.cancel_appeal_status_date') }}</span>
                                </span>
                                <span class="text-red-500">{{ momentToDate(form.statusCancelledAt) }}</span>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>

                      <div id="chat">
                        <ChatComponent v-if="form.objectId"
                          :disabled="isLoading || mode == 'create' || form.status == 'success' || mode == 'cancelled'"
                          :projectId="projectId" :marketId="marketId" :appeal="form" class="mt-4" />
                      </div>
                    </template>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-2">
                  <v-btn color="black" elevation="1" outlined large @click="closeAppealDialog()" :disabled="isLoading"
                    :loading="isLoading">{{ $t('close') }}</v-btn>
                  <v-btn v-if="checkPermission(form.subCategory).enableEdit && form.status_tmp != 'pending'"
                    v-show="isView && form.status_tmp != 'success' && mode != 'cancelled'" color="warning" elevation="1"
                    @click="changeView(false)" :loading="isLoading" large>{{ $t('account.edit_data') }}</v-btn>
                  <v-btn v-if="checkPermission(form.subCategory).enableEdit && form.status_tmp != 'pending'"
                    v-show="!isView && form.status_tmp != 'success' && mode != 'cancelled' && mode != 'create'"
                    color="error" elevation="1" @click="changeView(true)" :loading="isLoading" large>{{
                      $t('account.cancel_edit') }}</v-btn>
                  <v-spacer></v-spacer>
                  <div v-if="form.subCategory == 'installment_invoice' && sumInstallment().isPass">
                    {{ sumInstallment().text }}</div>
                  <v-btn color="primary" elevation="1" type="submit" large :loading="isLoading" v-show="!isView"
                    :disabled="(form.subCategory == 'installment_invoice' && sumInstallment().isPass) || isLoading">{{
                      $t('save')
                    }}</v-btn>
                  <v-btn
                    v-if="checkPermission(form.subCategory).enableSend && !checkPermission(form.subCategory).enableEdit && form.status_tmp == 'waiting'"
                    color="info" elevation="1" large :loading="isLoading" v-show="isView && mode == 'update'"
                    @click="isSendConfirm = true" :disabled="isLoading">{{ $t('task.send_approve') }}</v-btn>
                  <v-btn v-if="checkPermission(form.subCategory).enableEdit" color="error" elevation="1" large
                    :loading="isLoading" v-show="isView && mode == 'update'" @click="isCancelConfirm = true"
                    :disabled="form.isEffective || isLoading || (form.subCategory == 'renew_contract' && form.status_tmp == 'success')">{{
                      $t('appeal.cancel_appeal') }}</v-btn>
                  <v-btn
                    v-if="checkPermission(form.subCategory).enableEdit && (form.status_tmp == 'waiting' || form.status_tmp == 'pending')"
                    color="primary" elevation="1" large :loading="isLoading"
                    v-show="isView && mode == 'update' && form.status_tmp != 'success'" @click="isApproveConfirm = true"
                    :disabled="form.isEffective || isLoading">{{ $t('task.approve_appeal') }}</v-btn>
                  <v-btn v-if="form.status_tmp == 'approved'" color="primary" elevation="1" large :loading="isLoading"
                    v-show="isView && mode == 'update' && form.status_tmp != 'success'" @click="isSuccessConfirm = true"
                    :disabled="form.isEffective || isLoading">{{ $t('finish') }}</v-btn>
                  <v-btn
                    v-if="form.subCategory == 'document_shop_certify' && mode == 'update' && form.status_tmp == 'success'"
                    class="m-1" color="info" elevation="1" large @click="isPrintDialog = true" :loading="isLoading">
                    <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('print_document') }}
                  </v-btn>
                </v-card-actions>
              </v-form>
              <v-card-text v-if="isLoadAppeal" class="flex justify-center align-center"
                style="height: 600px; padding:30px;">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <template>
        <select-customer v-model="selectCustomerDialog" @select="dataCustomerDialog"
          :header="$t('payment.select_transferor')"></select-customer>
        <customer-search-dialog v-model="searchDialog" @select="selectCustomer"></customer-search-dialog>
        <v-dialog v-model="isFormImageLoading" persistent max-width="500px">
          <v-card color="primary" dark>
            <v-card-text class="text-center">
              <v-progress-circular indeterminate color="white" size="64"></v-progress-circular>
              <v-spacer></v-spacer>
              <span class="display-1 white--text">{{ $t('upload.uploading') }}</span>
            </v-card-text>
            <v-snackbar v-model="isError" color="error">{{ $t('upload.error_add_user') }}</v-snackbar>
          </v-card>
        </v-dialog>
        <!-- v-if="currentContract && currentContract.objectId" -->
        <invoice-dialog-component :projectId="getProjectId" :documentType="5" :contractData="currentContract"
          v-model="isInvoiceDialog" :invoiceId="currentInvoiceId"
          @onSaveSuccess="onSaveSuccess"></invoice-dialog-component>
        <PrintDialog elementId="print-appeal-document" type="appeal" v-model="isPrintDialog"
          :appealId="form.objectId" />

        <v-dialog v-model="isCancelConfirm" persistent max-width="600px">
          <v-form @submit.prevent="updateStatusAppeal('cancelled')" ref="confirm">
            <v-card>
              <v-card-title>{{ $t('appeal.you_want_to_cancel_appeal') }} {{ form.subCategory &&
                AppealLabels.subCategory[form.subCategory] ?
                ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) : ''
              }}?</v-card-title>
              <v-card-text>
                <div>
                  <span>{{ $t('appeal.reason_to_cancel_appeal') }}</span>
                  <div>
                    <v-textarea flat background-color="grey lighten-4" solo v-model="form.updatedStatusNote" required
                      :rules="rules.select"></v-textarea>
                  </div>
                  <div v-if="form.subCategory != 'installment_invoice'">
                    <v-icon color="warning">mdi-alert-circle</v-icon>
                    <span>
                      {{ $t('appeal.reason_to_cancel_appeal_description') }}
                      <b>{{ $t('market.show_to_tenant') }}</b>
                    </span>
                  </div>
                  <div v-if="form.status_tmp == 'success'">
                    <v-icon color="warning">mdi-alert-circle</v-icon>
                    <span>
                      {{ $t('appeal.warning_you_want_to_cancel_appeal') }} {{ form.subCategory &&
                        AppealLabels.subCategory[form.subCategory] ?
                        ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) : '' }}
                      <b>{{ $t('task.appeal_already_approved') }}</b>
                    </span>
                    <span v-if="form.subCategory == 'change_info_contact'">{{
                      $t('validate.name_or_company_name_has_been_changed') }}</span>
                    <span v-if="form.subCategory == 'change_owner_contact'">{{
                      $t('validate.transfer_right_has_been_transferred') }}</span>
                    <span v-if="form.subCategory == 'document_shop_certify'">{{
                      $t('validate.certificate_number_of_trade_right_will_still_be_in_the_system_but_cannot_be_printed')
                    }}</span>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" elevation="1" outlined large @click="isCancelConfirm = false" :disabled="isLoading"
                  :loading="isLoading">{{ $t('close') }}</v-btn>
                <v-btn color="success" elevation="1" :loading="isLoading" :disabled="isLoading" large type="submit">{{
                  $t('confirm') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="isSendConfirm" persistent max-width="600px">
          <v-form @submit.prevent="updateStatusAppeal('pending')" ref="confirm">
            <v-card>
              <v-card-title>{{ $t('appeal.you_want_to_send_appeal') }} {{ form.subCategory &&
                AppealLabels.subCategory[form.subCategory] ?
                ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) :
                '' }}?</v-card-title>

              <v-card-text>
                <div style="text-indent: 20px;">{{ $t('appeal.send_appeal_to_companion') }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" elevation="1" outlined large @click="isSendConfirm = false" :disabled="isLoading"
                  :loading="isLoading">{{ $t('close') }}</v-btn>
                <v-btn color="success" elevation="1" large :loading="isLoading" type="submit" :disabled="isLoading">{{
                  $t('appeal.send_appeal') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="isApproveConfirm" persistent max-width="600px">
          <v-form @submit.prevent="updateStatusAppeal('approved')" ref="confirm">
            <v-card>
              <v-card-title style="text-wrap: nowrap;">{{ $t('task.you_want_to_approve_appeal') }} {{ form.subCategory
                &&
                AppealLabels.subCategory[form.subCategory] ?
                ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) : ''
              }}?</v-card-title>

              <v-card-text v-if="false">
                <div style="text-indent: 20px;">{{ $t('task.when_approve_appeal') }} {{ form.subCategory &&
                  AppealLabels.subCategory[form.subCategory] ?
                  ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) : '' }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" elevation="1" outlined large @click="isApproveConfirm = false"
                  :disabled="isLoading" :loading="isLoading">{{ $t('close') }}</v-btn>
                <v-btn color="success" elevation="1" large :loading="isLoading" type="submit" :disabled="isLoading">{{
                  $t('task.approve') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="isSuccessConfirm" persistent max-width="550px">
          <v-form @submit.prevent="updateStatusAppeal('success')" ref="confirm">
            <v-card>
              <v-card-title>{{ $t('appeal.you_want_to_finish_appeal') }}{{ form.subCategory &&
                AppealLabels.subCategory[form.subCategory] ?
                ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) :
                '' }}?</v-card-title>
              <v-card-text>
                <div style="text-indent: 20px;">
                  {{ $t('appeal.when_finish_appeal') }} {{ form.subCategory &&
                    AppealLabels.subCategory[form.subCategory] ?
                    ($t(`appeal_data.subCategory.${AppealLabels.subCategory[form.subCategory].value}`)) : '' }}
                  <span v-if="form.subCategory == 'document_shop_certify'">
                    {{ $t('market.system_will_create_document_number_automatically') }}
                    <b>{{ $t('market.you_can_print_document') }}</b>
                  </span>
                  <span v-else-if="form.subCategory == 'change_info_contact'">
                    {{ $t('market.and_system') }}
                    <b>
                      {{ $t('market.change_data_as_follow') }}
                      <u>{{ $t('market.all_data_in_system') }}</u>
                    </b>{{ $t('market.automatically') }}
                  </span>
                  <span v-else-if="form.subCategory == 'change_owner_contact'">
                    {{ $t('market.and_system') }}
                    <b>
                      {{ $t('contract.transfer_stall_contract_right') }}
                      <u>{{ form.effectiveByStatus ? $t('market.immediately') : $t('market.on_date') +
                        form.effectiveDate_tmp }}</u>
                    </b>
                  </span>
                  <span v-else-if="form.subCategory == 'installment_invoice'">
                    {{ $t('market.and_system') }}
                    <b>
                      {{ $t('market.will_do_as_follow') }}
                      <u>{{ $t('market.send_installment_invoice') }}</u>
                      {{ $t('market.automatically_show_to_tenant') }}
                    </b>
                  </span>
                  <span style="margin-left:5px;">{{ $t('market.cannot_edit_data_again') }}</span>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" elevation="1" outlined large @click="isSuccessConfirm = false"
                  :disabled="isLoading" :loading="isLoading">{{ $t('close') }}</v-btn>
                <v-btn color="success" elevation="1" large :loading="isLoading" type="submit" :disabled="isLoading">{{
                  $t('task.approve') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="addAreaProductDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="green white--text">{{ $t('product.edit_product') }}</v-card-title>
            <v-card-text class="py-5">
              <span>{{ $t('product.select_product') }}</span>
              <v-autocomplete color v-model="products_tmp" :items="getProductNameOnly" :label="$t('product.title')"
                item-text="name" item-value="form" solo flat multiple return-object background-color="grey lighten-4">
                <template v-slot:append-outer>
                  <v-icon v-if="admin || (employee && employee.enableAddProduct)"
                    @click="isProductDialog = true">mdi-plus</v-icon>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon disabled>mdi-plus</v-icon>
                      </div>
                    </template>
                    <span>{{ $t('product.no_permission_to_add_product') }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-card-text>
            <v-card-actions class="mx-2">
              <v-spacer></v-spacer>
              <v-btn color="error" elevation="0"
                @click="addAreaProductDialog = false; currentAreaObjectIndex = null; products_tmp = [];">
                <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
              </v-btn>
              <v-btn color="success" elevation="0" @click="saveAreaProducts" :disabled="false">
                <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="closeConfirm" persistent max-width="550px">
          <v-card>
            <v-card-title>{{ $t('appeal.you_want_to_close_appeal_window') }}</v-card-title>
            <v-card-text>
              <div style="text-indent: 20px;">
                {{ $t('market.system_may_not_save_changes') }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click="closeConfirm = false" :disabled="isLoading" :loading="isLoading">{{ $t('cancel')
              }}</v-btn>
              <v-btn color="success" large :loading="isLoading" @click="isAppeal = false; closeConfirm = false"
                :disabled="isLoading">{{ $t('validate.confirm_to_close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <FormProduct v-model="isProductDialog" :event="`create`"></FormProduct>

        <ContractDocument v-model="isContractDocument" :projectId="projectId" :marketId="marketId"
          :contract-id="contractId || null" :isUpdate="true" :object-id="contractDocumentId" :isDisable="true" />
        <ContractsDocument v-model="isTempContractDocument" :projectId="projectId" :marketId="marketId"
          :isDisable="true" :document="contractDocument" />
      </template>
    </PermissionValidation>
  </div>
</template>

<script>
import AppealLabels from "../../json/appeal-data.json";
import Layout from "../../components/Layout.vue";
import Headline from "../../components/Headline.vue";
import ParentBar from "../../components/ParentBar.vue";
import AppealLayout from "../../components/AppealLayout.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
import CustomerSearchDialog from "../../components/CustomerSearchDialog.vue";
import CustomerCard from "../../components/CustomerCard.vue";
import InvoiceDialogComponent from "../../components/InvoiceDialog.component.vue";
import PrintDialog from "../../components/PrintDialog.component.vue";
import InvoiceContract from "../../components/InvoiceContract.vue";
import FormContract from "../../components/FormContract.vue";
import SelectCustomer from "../../components/SelectCustomer.vue";
import AutocompleteArea from "../../components/AutocompleteArea.vue";
import FormProduct from "../../components/FormProduct.vue";
import CardContractDocument from "../../components/CardContractDocument.vue";
import ContractDocument from "../../components/ContractDocument.vue";
import ConfirmDialog from "../../components/ConfirmDialog.vue";
import ContractsDocument from "../../components/ContractsDocument.vue";
import { FileUpload, Appeal } from "../../classes";
import { mapGetters, mapActions } from "vuex";
import ChatComponent from "@/components/Chat.component.vue";
import AppealStatusCard from "../../components/AppealStatusCard.component.vue";

export default {
  components: {
    Layout,
    Headline,
    ParentBar,
    AppealLayout,
    PermissionValidation,
    CustomerSearchDialog,
    InvoiceDialogComponent,
    CustomerCard,
    PrintDialog,
    InvoiceContract,
    SelectCustomer,
    AutocompleteArea,
    FormProduct,
    CardContractDocument,
    ContractDocument,
    ConfirmDialog,
    ContractsDocument,
    ChatComponent,
    AppealStatusCard
  },
  data() {
    return {
      AppealLabels,
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      maxFileUpload: 2097152,
      maxFileUploadText: "2MB",
      isMaxFileUpload: false,
      isMaxFileUploadAppealImage: false,
      isMaxFileUploadCitizenCard: false,
      isLoading: false,
      isLoadProducts: false,
      isAppeal: false,
      isLoadAppeal: false,
      isView: false,
      isContract: false,
      isCustomer: false,
      isLoadAreas: false,
      isLoadInvoice: false,
      isSendConfirm: false,
      isApproveConfirm: false,
      isCancelConfirm: false,
      isSuccessConfirm: false,
      searchDialog: false,
      isFormImageLoading: false,
      isInvoiceDialog: false,
      isPrintDialog: false,
      isProductDialog: false,
      isError: false,
      mode: null,
      currentCustomer: null,
      currentContract: null,
      currentInvoiceId: null,
      currentInvoices: [],
      currentContracts: [],
      currentAreas: [],
      currentAreaObjects: [],
      currentAreaObjectIndex: null,
      areasSelecter: [],
      menu1: false,
      menuEffectiveDate: false,
      selectCustomerDialog: false,
      addAreaProductDialog: false,
      renewOldContract: null,
      form: {
        marketId: this.$route.params.marketId,
        customer: null,
        customerId: "",
        contracts: [],
        contract: null,
        areas: [],
        category: "",
        subCategory: "",
        status: "",
        status_tmp: "",
        description: "",
        images: [],
        images_tmp: [],
        invoices: [],
        updatedStatusNote: "",
        effectiveDate: "",
        effectiveByStatus: true,
        effectiveDate_tmp: this.$moment().format("YYYY-MM-DD"),
        requestData: {
          companyName: "",
          prefixName: "",
          firstName: "",
          lastName: "",
          oldCompanyName: "",
          oldPrefixName: "",
          oldFirstName: "",
          oldLastName: "",
          oldCitizenCardImages: [],
          addressStreet: "",
          addressSubDistrict: "",
          addressDistrict: "",
          addressProvince: "",
          addressZipcode: "",
          citizenCardImages: [],
          citizenCardImages_tmp: [],
          reasonShopCertify: "",
          statusBeforeCancelled: "",
          relation: "",
          contractNewCustomer: "",
          startDateCertify: this.$moment().format("YYYY-MM-DD"),
          installmentInvoice: "",
          installmentInvoiceObject: "",
          installmentAmount: 0,
          dataInstallmentTable: [],
          areaProducts: [],
          otherType: "",
          issueDate: this.$moment().format("YYYY-MM-DD"),
          isSuspend: true,
          startDate: this.$moment().format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
          detail: "",
          penaltyDetail: "",
          suspendDays: 0,
        },
      },

      filterSelecter: ["all"],
      filterItem: [],
      filterStatus: undefined,
      categoryItem: undefined,
      subCategoryLabel: undefined,
      reasonShopCertifyItem: undefined,
      prefixName: undefined,
      installmentAmountItem: undefined,
      relationsLabel: undefined,
      rules: {
        select: [v => !!v || this.$t('validate.required_input')],
        select3: [v => !!v || this.$t('validate.required_select')],
        select2: [v => v && v.length > 0 || this.$t('validate.required_select')],
        loanMin: value => parseFloat(value) > 0 || this.$t('validate.time_must_be_greater_than_zero')
      },
      images_tmp: [],
      citizenCardImages_tmp: [],
      products_tmp: [],
      isFristTime: true,
      limit: 10,
      skip: 0,
      isLoadMore: false,
      isLoadingMore: false,
      tempCategories: null,
      tempStatus: null,
      renewContractDocuments: [],
      isLoadContractDocument: false,
      isContractDocument: false,
      contractId: '',
      contractDocumentId: '',
      closeConfirm: false,
      contractAreas: [],
      contractDocument: null,
      isTempContractDocument: false,
      issueDatePicker: false,
      startDatePicker: false,
      endDatePicker: false,
      isLoadingCount: false,
      customerType: "customer",
      limitIsSuccess: 10,
      limitIsCancelled: 10,
      menu: false,
      filterTimer: null,
      isFiltering: false,
      tempAppeals: [],
      previousFilterSelecter: [],
      activeFilterSelecter: ['all'],
      tempIsSuccessLast: null,
      tempIsCancelledLast: null,
      isMoreDataSuccess: true,
      isMoreDataCancelled: true,
      loadingMoreDataSuccess: false,
      loadingMoreDataCancelled: false,
      isHideLoadMoreSuccess: false,
      isHideLoadMoreCancelled: false,
      queryParamsAppealId: null,
      loadMoreCategories: [],
    };
  },
  computed: {
    ...mapGetters({
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
      customer: "customer/getCustomer",
      contracts: "contract/getContracts",
      getCustomerContract: "customer/getCustomerContract",
      getAddressArray: "customer/getAddressArray",
      getProjectId: "markets/getProjectId",
      getContract: "contract/getContract",
      getInvoice: "invoice/getInvoice",
      getInvoiceContract: "invoice/getInvoiceContract",
      getProducts: "product/getProducts",
      getProductNameOnly: "product/getProductNameOnly",
      appeals: "appeal/getAppeals",
      getAppealsSuccess: "appeal/getAppealsSuccess",
      getAppealsPending: "appeal/getAppealsPending",
      getAppealsWaiting: "appeal/getAppealsWaiting",
      getAppealsApproved: "appeal/getAppealsApproved",
      getAppealsCancelled: "appeal/getAppealsCancelled",
      getAreas: "markets/getAreas",
    }),
    subCategoryItem() {
      let subCategory = [];
      if (this.form.category != "all")
        subCategory = this.subCategoryLabel.filter(filter =>
          this.filterCategory(this.form.category, filter.category)
        );
      if (this.mode == "create") {
        this.form.areas = [];
        if (this.form.customer && this.customerType != "central") {
          this.getContractsByCustomer(this.form.customer.objectId);
        } else {
          this.getAllAreas();
        }
      }
      return this.mode == 'create' ? subCategory.filter(s => !s.isHidden) : subCategory;
    },
    subCategoryText() {
      let data = "";
      if (this.form.subCategory) {
        data =
          this.form.subCategory &&
            this.AppealLabels.subCategory[this.form.subCategory]
            ? this.AppealLabels.subCategory[this.form.subCategory].text
            : "";
      }
      return data;
    },
    filterContractBySelectArea() {
      let data = [];
      if (
        this.form.contracts &&
        this.form.contracts.length &&
        this.form.areas &&
        this.form.areas.length &&
        this.form.subCategory != "change_owner_contact" &&
        this.form.subCategory != "installment_invoice" &&
        this.form.subCategory != "other"
      ) {
        for (const contract of this.form.contracts) {
          let resIn;
          if (this.form.areas[0].objectId) {
            const resAreas = this.form.areas
              .filter(res => res.objectId)
              .map(ele => ele.objectId);
            resIn = contract.areas.filter(area =>
              resAreas.includes(area.objectId)
            );
          } else if (contract.areas) {
            resIn = contract.areas.filter(area =>
              this.form.areas.includes(area.objectId)
            );
          }
          if (resIn && resIn.length) {
            data.push(contract);
          }
        }
      } else if (
        (this.form.subCategory == "change_owner_contact" ||
          this.form.subCategory == "installment_invoice") &&
        this.form.contract
      ) {
        this.form.areas = this.form.contract.areas;
        data.push(this.form.contract);
      } else if (this.form.subCategory == "other" && this.form.contract) {
        data.push(this.form.contract);
      }
      return data;
    },
    invoiceContractItem() {
      let res = [];
      if (this.mode == "create") res = this.getInvoiceContract;
      else {
        let idx = this.getInvoiceContract.findIndex(
          item => item.objectId == this.form.requestData.installmentInvoice
        );
        if (idx > -1) {
          res = [this.getInvoiceContract[idx]];
        }
      }
      return res;
    },
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    uniqueCurrentContracts() {
      if (!this.currentContracts) return [];
      const uniqueContracts = new Map();
      this.currentContracts.forEach(contract => {
        if (!uniqueContracts.has(contract.contractId)) {
          uniqueContracts.set(contract.contractId, contract);
        }
      });
      return Array.from(uniqueContracts.values());
    },
    getSelectedFilterText() {
      if (!this.filterSelecter || this.filterSelecter.length === 0) {
        return 'Select filters';
      }

      if (this.filterSelecter.includes('all')) {
        return this.$t('all_appeals');
      }

      return this.filterSelecter.map(f => {
        const item = this.filterItem.find(item => item.value === f);
        return item ? this.$t(`appeal_data.category.${item.value}`) : '';
      }).filter(text => text).join(', ');
    },
  },
  created() {
    this.prepareLabel();
    this.getAllProducts();
    this.queryParamsAppealId = this.$route.query.appealId;
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions({
      getContractDocuments: 'contractDocument/getContractDocuments',
      removeContractDocument: 'contractDocument/removeContractDocument',
      getAppeals: 'appeal/getAppeals'
    }),
    checkPermission(subCategory) {
      let res = { enableEdit: false, enableSend: false };
      if (this.admin) {
        res.enableEdit = true;
        res.enableSend = true;
      }
      if (
        this.employee &&
        this.employee.enableAppealObject &&
        subCategory &&
        this.employee.enableAppealObject[subCategory]
      ) {
        res = this.employee.enableAppealObject[subCategory];
      }
      return res;
    },
    prepareLabel() {
      this.categoryItem = [];
      this.subCategoryLabel = [];
      this.filterItem = [];
      this.filterStatus = [];
      this.prefixName = this.AppealLabels.prefixName;
      this.relationsLabel = this.AppealLabels.relations.filter(
        d => d != this.$t('relative')
      );
      this.installmentAmountItem = this.AppealLabels.installmentAmount;
      this.reasonShopCertifyItem = this.AppealLabels.reasonShopCertifyItem;
      for (const idx in this.AppealLabels.status) {
        let status = this.AppealLabels.status[idx];
        this.filterStatus.push(status);
      }
      for (const idx in this.AppealLabels.category) {
        let category = this.AppealLabels.category[idx];
        // if (!category.isHidden)
        this.categoryItem.push(category);
        this.filterItem.push(category);
      }
      for (const idx in this.AppealLabels.subCategory) {
        let subCategory = this.AppealLabels.subCategory[idx];
        this.subCategoryLabel.push(subCategory);
      }
    },
    async initData() {
      try {
        this.isLoading = true;
        if (this.isFristTime) {
          const [market, mainAppeals, resSuccess, resCancelled] = await Promise.all([
            this.$store.dispatch("markets/getMarketArea", { id: this.marketId }),
            this.getAppeals({
              marketId: this.marketId,
              status: ["waiting", "pending", "approved"],
              clearExisting: true
            }),
            this.getAppealsByStatus(["success"], this.limitIsSuccess),
            this.getAppealsByStatus(["cancelled"], this.limitIsCancelled)
          ])
          this.isMoreDataSuccess = resSuccess.length >= this.limitIsSuccess ? true : false
          this.isMoreDataCancelled = resCancelled.length >= this.limitIsCancelled ? true : false
          this.isHideLoadMoreSuccess = resSuccess.length < this.limitIsSuccess ? true : false
          this.isHideLoadMoreCancelled = resCancelled.length < this.limitIsCancelled ? true : false
        } else {
          await this.getAppeals({
            marketId: this.marketId,
            status: ["waiting", "pending", "approved"],
            clearExisting: true
          })
        }
        this.isFristTime = false
        this.isLoading = false;
        if (this.queryParamsAppealId) {
          this.openAppealByQueryParams();
        }
      } catch (error) {
        console.log(error);
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
    },
    async getAppealsByStatus(status, limit) {
      return await this.getAppeals({
        marketId: this.marketId,
        status,
        limit,
      })
    },
    async loadMoreDataSuccess() {
      this.loadingMoreDataSuccess = true
      try {
        this.tempIsSuccessLast = this.getAppealsSuccess[this.getAppealsSuccess.length - 1]
        let res = await this.getAppeals({
          marketId: this.marketId,
          status: ['success'],
          limit: this.limitIsSuccess,
          endDate: this.$moment(this.tempIsSuccessLast.createdAt).toDate(),
          categories: this.loadMoreCategories.length > 0 ? this.loadMoreCategories : undefined
        })
        if (res.length < this.limitIsSuccess) {
          this.isMoreDataSuccess = false
        }
        this.loadingMoreDataSuccess = false
      } catch (error) {
        this.loadingMoreDataSuccess = false
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
    },
    async loadMoreDataCancelled() {
      this.loadingMoreDataCancelled = true
      try {
        this.tempIsCancelledLast = this.getAppealsCancelled[this.getAppealsCancelled.length - 1]
        let res = await this.getAppeals({
          marketId: this.marketId,
          status: ['cancelled'],
          limit: this.limitIsCancelled,
          endDate: this.$moment(this.tempIsCancelledLast.createdAt).toDate(),
          categories: this.loadMoreCategories.length > 0 ? this.loadMoreCategories : undefined
        })
        if (res.length < this.limitIsCancelled) {
          this.isMoreDataCancelled = false
        }
        this.loadingMoreDataCancelled = false
      } catch (error) {
        this.loadingMoreDataCancelled = false
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
    },
    async getAllProducts() {
      if (
        !this.getProducts ||
        (this.getProducts && this.getProducts.length == 0)
      )
        try {
          this.isLoadProducts = true;
          await this.$store.dispatch("product/getProducts", {
            projectId: this.projectId
          });
          this.isLoadProducts = false;
        } catch (error) {
          console.log(error);
          this.$toast.show({
            content: this.$helper.ShowToastCatchError(error),
            color: "error"
          });
        }
    },
    async getContractsByCustomer(customerId, mode = "create") {
      this.currentAreas = [];
      this.currentContracts = [];
      this.isLoadAreas = true;
      try {
        if (mode == "create") {
          await this.$store.dispatch("contract/getContractsByCustomer", {
            customerId,
            marketId: this.marketId
          });
          this.form.contracts = this.contracts;
        }
        for (const contract of this.form.contracts) {
          if (contract.isActive) {
            this.currentContracts.push(contract);
          }
          for (let area of contract.areas) {
            area.contract = {
              objectId: contract.objectId,
              isSuspend: contract.isSuspend,
              endDate: contract.endDate,
              businessName: contract.businessName,
            }
            if (contract.closeContractAt) {
              area.contract.closeContractAt = contract.closeContractAt
            }
            if (area.isOccupied || true) {
              if (!this.currentAreas) this.currentAreas = [];
              area.text = `${area.name || ""} ${!contract.isActive
                ? `(${this.$t('contract.close_rental_contract')})` : area.closeContractAt
                  ? `(${this.$t('area.close_contract')})` : area.isOccupied
                    ? `(${this.$t('customer.in_rental_agreement')})`
                    : `(${this.$t('customer.rental_agreement_expired')})`
                }`;
              this.currentAreas.push(area);
            }
          }
        }
        this.isLoadAreas = false;
      } catch (e) {
        this.isLoadAreas = false;
      }
    },
    async getCustomer(customerId) {
      try {
        const response = await this.$store.dispatch("customer/getCustomer", {
          id: customerId
        });
        this.form.customer = this.customer;
        if (this.customer) {
          this.form.requestData.companyName = this.customer.companyName || "";
          this.form.requestData.prefixName = this.customer.title || "";
          this.form.requestData.firstName = this.customer.firstName || "";
          this.form.requestData.lastName = this.customer.lastName || "";
          this.form.requestData.oldCompanyName =
            this.customer.companyName || "";
          this.form.requestData.oldPrefixName = this.customer.title || "";
          this.form.requestData.oldFirstName = this.customer.firstName || "";
          this.form.requestData.oldLastName = this.customer.lastName || "";
          this.form.requestData.oldCitizenCardImages =
            this.customer.citizenCardImages || "";
        }
      } catch (e) {
        this.$toast.show({
          content: this.$t('validate.error_call_customer_data'),
          color: "error"
        });
      }
    },
    async createAppeal() {
      try {
        if (this.$refs.form.validate()) {
          this.isLoading = true;
          this.form.images = this.images_tmp;
          this.form.requestData.citizenCardImages = this.citizenCardImages_tmp;
          this.form.customerType = this.customerType;
          if (this.form.subCategory == "change_owner_contact") {
            this.form.contracts = [this.form.contract];
            this.form.effectiveDate = this.$moment(
              this.form.effectiveDate_tmp,
              "YYYY-MM-DD"
            ).toDate();
          } else {
            this.form.effectiveDate = undefined;
          }
          if (this.form.subCategory == "installment_invoice") {
            this.form.contracts = [this.form.contract];
            let dataInstallment = [];
            for (const data of this.form.requestData.dataInstallmentTable) {
              dataInstallment.push({
                amount: data.amount,
                dueDate: this.$moment(data.dueDate, "YYYY-MM-DD")
                  .endOf("day")
                  .toDate(),
                totalValue: data.totalValue
              });
            }
            this.form.requestData.dataInstallmentTable = dataInstallment;
          }
          if (this.form.subCategory == "other") {
            this.form.contracts = this.form.contract ? [this.form.contract] : null;
          }
          if (this.form.category == "suspend") {
            this.form.contracts = [this.form.contract];
            this.form.requestData.issueDate = this.$moment(
              this.form.requestData.issueDate,
              "YYYY-MM-DD"
            ).startOf("day").toDate();
            this.form.requestData.startDate = this.$moment(
              this.form.requestData.startDate,
              "YYYY-MM-DD"
            ).startOf("day").toDate();
            this.form.requestData.endDate = this.$moment(
              this.form.requestData.endDate,
              "YYYY-MM-DD"
            ).endOf("day").toDate();
          }
          setTimeout(async () => {
            const create = await this.$store.dispatch(
              "appeal/createAppeal",
              this.form
            );
            this.clearAppealDialog();
            this.isLoading = false;
            this.openAppeal('update', create)
          }, 200);
        } else {
          this.isInputError = true;
        }
      } catch (err) {
        console.log("~ err", err);
        this.isLoading = false;
        this.isError = true;
      }
    },
    async updateAppeal() {
      try {
        if (this.$refs.form.validate()) {
          this.isLoading = true;
          this.form.images = this.images_tmp;
          this.form.requestData.citizenCardImages = this.citizenCardImages_tmp;
          if (this.form.subCategory == "change_owner_contact") {
            this.form.effectiveDate = this.$moment(
              this.form.effectiveDate_tmp,
              "YYYY-MM-DD"
            ).toDate();
          } else {
            this.form.effectiveDate = undefined;
          }
          if (this.form.subCategory == "installment_invoice" && false) {
            let dataInstallment = [];
            for (const data of this.form.requestData.dataInstallmentTable) {
              dataInstallment.push({
                amount: data.amount,
                dueDate: this.$moment(data.dueDate, "YYYY-MM-DD")
                  .endOf("day")
                  .toDate(),
                totalValue: data.totalValue
              });
            }
            this.form.requestData.dataInstallmentTable = dataInstallment;
          }
          if (this.form.category == "suspend") {
            this.form.requestData.issueDate = this.$moment(
              this.form.requestData.issueDate,
              "YYYY-MM-DD"
            ).startOf("day").toDate();
            this.form.requestData.startDate = this.$moment(
              this.form.requestData.startDate,
              "YYYY-MM-DD"
            ).startOf("day").toDate();
            this.form.requestData.endDate = this.$moment(
              this.form.requestData.endDate,
              "YYYY-MM-DD"
            ).endOf("day").toDate();
          }
          setTimeout(async () => {
            const create = await this.$store.dispatch(
              "appeal/updateAppeal",
              this.form
            );
            this.clearAppealDialog();
            this.isLoading = false;
            this.openAppeal('update', create)
          }, 200);
        } else {
          this.isInputError = true;
        }
      } catch (err) {
        console.log("~ err", err);
        this.isLoading = false;
        this.isError = true;
      }
    },
    async updateStatusAppeal(status) {
      if (this.$refs.confirm.validate()) {
        this.isLoading = true;
        if (status == "cancelled") {
          this.form.requestData.statusBeforeCancelled = this.form.status;
        }
        if (status == "approved" && this.form.subCategory == "renew_contract") {
          this.form.status = "success"
        } else {
          this.form.status = status;
        }
        setTimeout(async () => {
          try {
            const create = await this.$store.dispatch(
              "appeal/changeStatusAppeal",
              this.form
            );
            this.clearAppealDialog();
          } catch (err) {
            this.isLoading = false;
            this.$toast.show({
              color: "error",
              content: err?.response?.data?.error || this.$t('error_please_try_again')
            })
          }
          this.isLoading = false;
          this.isAppeal = false;
          this.isSuccessConfirm = false;
          this.isCancelConfirm = false;
          this.isSendConfirm = false;
          this.isApproveConfirm = false;
        }, 200);
      } else {
        this.isInputError = true;
      }
    },
    async onSaveSuccess() {
      if (this.currentInvoiceId) {
        await this.$store.dispatch("invoice/getById", {
          invoiceId: this.currentInvoiceId,
          marketId: this.marketId,
          projectId: this.getProjectId
        });
      }
      if (this.getInvoice) {
        let tempInv = -1;
        if (this.form.invoices)
          tempInv = this.form.invoices.findIndex(
            invoice => invoice.objectId == this.getInvoice.objectId
          );
        if (tempInv < 0) {
          this.form.invoices.push(this.getInvoice);
        } else {
          this.form.invoices[tempInv] = this.getInvoice;
        }
        await this.$store.dispatch(
          "appeal/updateAppeal",
          {
            objectId: this.form.objectId,
            invoices: this.form.invoices
          }
        );
        this.initData();
      }
      this.currentContract = null;
      this.billingSelectDialog = false;
    },
    filterCategory(filter, category) {
      if (category == filter) {
        return true;
      }
      return false;
    },
    filterStatusFn(filter, status) {
      if (status == filter) {
        return true;
      }
      return false;
    },
    filterSubCategory(filter, category) {
      if (category == filter) {
        return true;
      }
      return false;
    },
    filterByValue(array, arr2) {
      return array.filter(item => !arr2.includes(item.objectId));
    },
    async openAppeal(mode, item) {
      this.clearAppealDialog();
      this.mode = mode;
      this.isAppeal = true;
      this.isLoadAppeal = true;
      if (mode == "create") {
        this.isView = false;
        this.form.status = "waiting";
        if (this.customer) {
          this.form.requestData.companyName = this.customer.companyName || "";
          this.form.requestData.prefixName = this.customer.prefixName || "";
          this.form.requestData.firstName = this.customer.firstName || "";
          this.form.requestData.lastName = this.customer.lastName || "";
          this.form.requestData.oldCompanyName =
            this.customer.companyName || "";
          this.form.requestData.oldPrefixName = this.customer.prefixName || "";
          this.form.requestData.oldFirstName = this.customer.firstName || "";
          this.form.requestData.oldLastName = this.customer.lastName || "";
          this.form.requestData.oldCitizenCardImages =
            this.customer.citizenCardImages || "";
        }
        this.form.category =
          this.filterSelecter == "all" ? "" : this.filterSelecter;
        this.customerType = "customer";
      } else if (mode == "update") {
        this.isView = true;
        this.form = Object.assign({}, item);
        this.form.status_tmp = this.form.status;
        this.form.images_tmp = this.form.images;
        this.form.requestData.citizenCardImages_tmp = this.form.requestData.citizenCardImages;
        this.customerType = this.form.customerType ? this.form.customerType : this.form.customer ? "customer" : "central";
        this.images_tmp = this.form.images;
        this.citizenCardImages_tmp = this.form.requestData.citizenCardImages;
        if (this.form.subCategory == "change_owner_contact") {
          this.form.contract = this.form.contracts[0];
        }
        if (this.form.category == "suspend") {
          this.form.contract = this.form.contracts[0];
          this.form.requestData.issueDate = this.$moment(
            this.form.requestData.issueDate,
          ).format("YYYY-MM-DD");
          this.form.requestData.startDate = this.$moment(
            this.form.requestData.startDate
          ).format("YYYY-MM-DD");
          this.form.requestData.endDate = this.$moment(
            this.form.requestData.endDate
          ).format("YYYY-MM-DD");
        }
        if (this.form.effectiveDate) {
          this.form.effectiveDate_tmp = this.$moment(
            this.form.effectiveDate.iso
          ).format("YYYY-MM-DD");
        }
        if (this.form.subCategory == "installment_invoice") {
          this.form.contract = this.form.contracts[0];
          await this.getInvoiceById(this.form.requestData.installmentInvoice);
        }
        if (this.form.subCategory == "other") {
          this.form.contract = this.form.contracts[0] || null;
          this.contractAreas = this.form.contract?.areas || []
          for (let area of this.form.areas) {
            if (!this.contractAreas.find(item => item.objectId == area.objectId)) {
              this.contractAreas.push(area)
            }
          }
        }
        if (this.form.customer && this.customerType != "central") {
          await this.getContractsByCustomer(this.form.customer.objectId, mode);
        } else {
          this.getAllAreas();
        }
        if (this.form.status == "cancelled") this.mode = "cancelled";
      }
      if (this.form.subCategory == "renew_contract") {
        if (this.form.renewNewContract) this.form.renewNewContract.contractDocument = await this.loadContractDocuments(this.form.renewNewContract.objectId)
        if (this.form.renewOldContract) this.form.renewOldContract.contractDocument = await this.loadContractDocuments(this.form.renewOldContract.objectId)
      }
      this.isLoadAppeal = false;
      this.editEndDate();
    },
    openAppealByQueryParams() {
      if (this.queryParamsAppealId) {
        let appeal = this.appeals.find(item => item.objectId == this.queryParamsAppealId);
        if (appeal) {
          this.openAppeal('update', appeal);
          if (window.location.hash) {
            const targetId = window.location.hash.substring(1);
            const tryScrollToElement = () => {
              const element = document.getElementById(targetId);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            };
            setTimeout(() => {
              tryScrollToElement();
            }, 1000);
          }
        }
        this.queryParamsAppealId = null;
        this.$router.replace({ query: {} });
      }
    },
    changeView(view) {
      this.isView = view;
    },
    clearAppealDialog() {
      this.isMaxFileUpload = false;
      this.isMaxFileUploadAppealImage = false;
      this.isMaxFileUploadCitizenCard = false;
      this.currentAreas = [];
      this.images_tmp = [];
      this.citizenCardImages_tmp = [];
      this.currentAreaObjects = [];
      this.currentAreaObjectIndex = [];
      this.products_tmp = [];
      this.form = {
        marketId: this.$route.params.marketId,
        customer: null,
        customerId: "",
        contracts: [],
        contract: null,
        areas: [],
        category: "",
        subCategory: "",
        status: "",
        description: "",
        images: [],
        images_tmp: [],
        invoices: [],
        updatedStatusNote: "",
        effectiveByStatus: true,
        effectiveDate: "",
        effectiveDate_tmp: this.$moment().format("YYYY-MM-DD"),
        requestData: {
          companyName: "",
          prefixName: "",
          firstName: "",
          lastName: "",
          oldCompanyName: "",
          oldPrefixName: "",
          oldFirstName: "",
          oldLastName: "",
          oldCitizenCardImages: [],
          addressStreet: "",
          addressSubDistrict: "",
          addressDistrict: "",
          addressProvince: "",
          addressZipcode: "",
          citizenCardImages: [],
          citizenCardImages_tmp: [],
          reasonShopCertify: "",
          statusBeforeCancelled: "",
          relation: "",
          contractNewCustomer: "",
          startDateCertify: this.$moment().format("YYYY-MM-DD"),
          installmentInvoice: "",
          installmentInvoiceObject: "",
          installmentAmount: 0,
          dataInstallmentTable: [],
          areaProducts: [],
          otherType: "",
          issueDate: this.$moment().format("YYYY-MM-DD"),
          isSuspend: true,
          startDate: this.$moment().format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD"),
          detail: "",
          penaltyDetail: "",
          suspendDays: 0,
        },
        customerType: "customer"
      };
      this.customerType = "customer";
    },
    afterCreate(object) {
      if (this.mode == "create") {
        this.isAppeal = false;
      }
    },
    selectCustomer(value) {
      this.form.customer = value;
      if (this.form.customer?.objectId) {
        this.form.customerId = this.form.customer.objectId;
        this.form.contract = null;
        this.form.areas = [];
        this.getCustomer(this.form.customer.objectId);
        this.getContractsByCustomer(this.form.customer.objectId);
      }
    },
    changeAreas(areas) {
      if (
        areas &&
        areas.length &&
        this.currentAreas &&
        this.currentAreas.length &&
        this.form.subCategory == "change_product_contact" &&
        this.mode == "create"
      ) {
        this.form.requestData.areaProducts = [];
        let currentAreaObjects = {};
        for (let currentArea of this.currentAreas) {
          let ojb = {
            objectId: currentArea.objectId,
            name: currentArea.name,
            products:
              currentArea.products.map(pd => {
                return { objectId: pd.objectId, name: pd.name };
              }) || [],
            newProducts: []
          };
          currentAreaObjects[currentArea.objectId] = ojb;
        }
        for (const areaId of areas) {
          if (currentAreaObjects[areaId]) {
            this.form.requestData.areaProducts.push(currentAreaObjects[areaId]);
          }
        }
      }
    },
    async uploadFile(e, to = [], errorId = "", type = "") {
      if (e) {
        try {
          this.isFormImageLoading = true;
          if (e.size <= this.maxFileUpload) {
            const data = await FileUpload.upload(e);
            to.push(data);
            if (type == 'appeal_image') {
              this.isMaxFileUploadAppealImage = false;
            } else if (type == 'citizen_card') {
              this.isMaxFileUploadCitizenCard = false;
            }
            if (errorId) {
              document.getElementById(errorId).style.display = "none";
            }
          } else {
            if (type == 'appeal_image') {
              this.isMaxFileUploadAppealImage = true;
            } else if (type == 'citizen_card') {
              this.isMaxFileUploadCitizenCard = true;
            }
            if (errorId) {
              document.getElementById(errorId).style.display = "block";
            }
          }
          this.isFormImageLoading = false;
        } catch (err) {
          console.log("~ err", err);
          this.isFormImageLoading = false;
        }
      }
    },
    fullName(customer) {
      let fullname = "";
      if (customer) {
        fullname = `${customer.title || ""} ${customer.firstName ||
          "-"} ${customer.lastName || "-"}`;
      }
      if (!fullname) fullname = this.$t('not_specified');
      return fullname;
    },
    fullAddress(customer) {
      let fulladdress = "";
      if (customer) {
        fulladdress = `${customer.addressStreet ||
          ""} ${customer.addressSubDistrict || ""} ${customer.addressDistrict ||
          ""}  ${customer.addressProvince || ""}  ${customer.addressZipcode ||
          ""}`;
      }
      if (!fulladdress) fulladdress = this.$t('not_specified');
      return fulladdress;
    },
    async createInvoice(contract) {
      this.currentInvoiceId = null;
      if (contract) this.currentContract = contract;
      else this.currentContract = this.form.contracts[0];
      if (this.currentContract)
        await this.$store.dispatch("contract/getContract", {
          id: this.currentContract.objectId
        });
      this.isInvoiceDialog = true;
    },
    openInvoice(contract, invoiceId) {
      this.currentInvoiceId = invoiceId;
      this.currentContract = contract;
      this.isInvoiceDialog = true;
    },
    momentFromNow(date) {
      let res = "";
      if (date) res = this.$moment(date).fromNow();
      else res = "-";
      return res;
    },
    momentToDate(date, format = "datetime") {
      let res = "";
      let formatDate = "DD MMM YYYY, HH:mm " + this.$t('timeunit.minute.short');
      if (format == "date") formatDate = "DD MMM YYYY";
      if (format == "datetimesec") formatDate = "DD MMM YYYY, HH:mm:ss";
      if (date?.iso) res = this.$moment(date.iso).format(formatDate);
      else if (date) res = this.$moment(date).format(formatDate);
      else res = "-";
      return res;
    },
    statusInvoice(invoice) {
      if (invoice.isPaid) {
        return this.$t('payment.already_paid');
      } else if (invoice.isSent) {
        return this.$t('payment.pending');
      } else if (invoice.documentId) {
        return this.$t('bill.edit_bill');
      } else {
        return this.$t('payment.wait_approval');
      }
    },
    shopCertifyNo(appeal) {
      let res = "";
      if (appeal && appeal.documentRunningYear && appeal.documentRunningNumber)
        res = `${this.$t('gor_kor')} ${appeal.documentRunningYear ||
          "-"}-${appeal.documentRunningNumber.toLocaleString("en-US", {
            minimumIntegerDigits: 4,
            useGrouping: false
          })}${appeal.status_tmp == "cancelled" ? ` (${this.$t('canceled')})` : ""}`;
      return res;
    },
    removeImageUpload(index, to = [], errorId = "", type = "") {
      if (to && to.length) {
        to.splice(index, 1);
      }
      if (errorId) {
        document.getElementById(errorId).style.display = "none";
        if (type == 'appeal_image') {
          this.isMaxFileUploadAppealImage = false;
        } else if (type == 'citizen_card') {
          this.isMaxFileUploadCitizenCard = false;
        }
      }
    },
    imageError(name) {
      let image = document.getElementById(name);
      if (image) image.style.display = "none";
    },
    dataCustomerDialog(value) {
      this.form.requestData.contractNewCustomer = value;
      this.selectCustomerDialog = false;
    },
    getCustomers() {
      this.selectCustomerDialog = true;
    },
    changeEffectiveDate(e) {
      if (e) {
        this.form.effectiveDate_tmp = undefined;
      } else {
        this.form.effectiveDate_tmp = this.$moment()
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
    },
    async selectContract(e) {
      if (e) {
        this.form.areas = []
        this.contractAreas = e.areas
        this.isLoadInvoice = true;
        await this.getInvoicesByContractInAppeal(e.objectId);
        this.form.contract = e;
        this.isLoadInvoice = false;
      }
    },
    async getInvoiceById(invoiceId) {
      await this.$store.dispatch("invoice/getInvoiceContract", {
        invoiceId,
        marketId: this.marketId
      });
    },
    async getInvoicesByContractInAppeal(contractId) {
      await this.$store.dispatch("invoice/getInvoicesByContractInAppeal", {
        contractId,
        marketId: this.marketId,
        projectId: this.getProjectId
      });
    },
    selectInvoice(e) {
      if (e) {
        let idx = this.getInvoiceContract.findIndex(item => item.objectId == e);
        if (idx > -1) {
          this.form.requestData.installmentInvoiceObject = this.getInvoiceContract[
            idx
          ];
        }
        this.form.requestData.installmentAmount = 0;
        this.form.requestData.dataInstallmentTable = [];
      }
    },
    selectInstallmentAmount(e) {
      if (e && this.form.requestData.installmentInvoice) {
        this.form.requestData.dataInstallmentTable = [];
        let totalValue = this.form.requestData.installmentInvoiceObject
          .totalValue;
        let sumValue = 0;
        for (let amount = 1; amount <= e; amount++) {
          let res = {
            isDateMenu: false,
            amount,
            dueDate: this.$moment()
              .add(amount, "months")
              .endOf("month")
              .format("YYYY-MM-DD"),
            totalValue: Number(totalValue / e).toFixed(0)
          };
          sumValue += Number(res.totalValue);
          if (amount == e && sumValue !== totalValue) {
            res.totalValue = Number(
              Number(res.totalValue) - (sumValue - totalValue)
            ).toFixed(0);
          }
          this.form.requestData.dataInstallmentTable.push(res);
        }
      }
    },
    sumInstallment() {
      let dataInstallment = this.form.requestData.dataInstallmentTable;
      let totalValue = this.form.requestData.installmentInvoiceObject
        .totalValue;
      let res = { isPass: false, diff: 0, text: "" };
      let sum = 0;
      if (dataInstallment && dataInstallment.length) {
        sum = dataInstallment.reduce(
          (accumulator, object) => accumulator + parseFloat(object.totalValue),
          0
        );
      }
      sum = Math.round(sum * 100000000) / 100000000;
      if (sum && totalValue && totalValue != sum) {
        let diff = sum - totalValue;
        res.text = `${diff > 0 ? this.$t('overdue') : this.$t('missed')} ${diff.toFixed(2)}`;
        res.isPass = true;
        res.diff = diff.toFixed(2);
      }
      return res;
    },
    clickAddProduct(area = [], index) {
      this.products_tmp = area.newProducts || [];
      this.currentAreaObjectIndex = index;
      this.addAreaProductDialog = true;
    },
    saveAreaProducts() {
      if (
        this.currentAreaObjectIndex >= 0 &&
        this.form.requestData.areaProducts[this.currentAreaObjectIndex]
      )
        this.form.requestData.areaProducts[
          this.currentAreaObjectIndex
        ].newProducts = this.products_tmp || [];
      this.addAreaProductDialog = false;
    },
    onChangeFilter() {
      if (!this.filterSelecter) {
        this.filterSelecter = [];
      }

      const lastSelected = this.filterSelecter[this.filterSelecter.length - 1];
      if (lastSelected === 'all') {
        this.filterSelecter = ['all'];
      } else if (this.filterSelecter.length === 0) {
        this.filterSelecter = ['all'];
      } else {
        this.filterSelecter = this.filterSelecter.filter(d => d !== 'all');
      }

      if (this.filterTimer) {
        clearTimeout(this.filterTimer);
      }

      this.isFiltering = true;
      const newFilter = [...this.filterSelecter];

      this.filterTimer = setTimeout(async () => {
        await this.loadAppealByCategories();
        this.isFiltering = false;
        this.activeFilterSelecter = newFilter;
      }, 1000);
    },
    async loadAppealByCategories() {
      this.limitIsSuccess = 10;
      this.limitIsCancelled = 10;

      this.$store.commit("appeal/clearAppealsSuccess");
      this.$store.commit("appeal/clearAppealsCancelled");

      let [appealSuccess, appealCancelled] = await Promise.all([
        this.getAppeals({
          marketId: this.marketId,
          status: ['success'],
          limit: this.limitIsSuccess,
          categories: this.filterSelecter.filter(d => d !== 'all'),
        }),
        this.getAppeals({
          marketId: this.marketId,
          status: ['cancelled'],
          limit: this.limitIsCancelled,
          categories: this.filterSelecter.filter(d => d !== 'all'),
        })
      ])

      this.loadMoreCategories = [...this.filterSelecter.filter(d => d !== 'all')];
      if(appealSuccess.length < this.limitIsSuccess) {
        this.isMoreDataSuccess = false;
      } else {
        this.isMoreDataSuccess = true;
      }
      if(appealCancelled.length < this.limitIsCancelled) {
        this.isMoreDataCancelled = false;
      } else {
        this.isMoreDataCancelled = true;
      }
    },
    filterAppeals(appeals) {
      const filterToUse = this.isFiltering ? this.activeFilterSelecter : this.filterSelecter;
      if (filterToUse.includes('all')) {
        return appeals;
      }
      return appeals.filter(appeal =>
        filterToUse.includes(appeal.category)
      );
    },
    async loadContractDocuments(contractId) {
      let resContractDocument = []
      if (contractId) {
        this.isLoadContractDocument = true
        resContractDocument = await this.getContractDocuments({
          contractId: contractId,
          isRenewContract: true
        });
        this.isLoadContractDocument = false
      }
      return resContractDocument
    },
    contractDocumentDialog(e, contractId) {
      this.contractId = contractId
      this.contractDocumentId = e.objectId;
      this.isContractDocument = true;
    },
    tempContractsDocumentDialog(e, isDisable = false) {
      if (isDisable) {
        this.contractDocument = e;
      } else {
        this.contractDocument = null;
      }
      this.isContractDocumentDisable = isDisable || false;
      this.isTempContractDocument = true;
    },
    closeAppealDialog() {
      if (this.mode == "create") {
        this.closeConfirm = true
      } else if (this.mode == "update") {
        if (this.isView && this.form.status == 'success') this.isAppeal = false
        else if (!this.isView && this.form.status == 'success') this.closeConfirm = true

        else if (this.isView && this.form.status == 'waiting') this.isAppeal = false
        else if (!this.isView && this.form.status == 'waiting') this.closeConfirm = true

        else if (this.isView && this.form.status == 'pending') this.isAppeal = false
        else if (!this.isView && this.form.status == 'pending') this.isAppeal = false

        else if (this.isView && this.form.status == 'approved') this.isAppeal = false
        else if (!this.isView && this.form.status == 'approved') this.closeConfirm = true

        else this.isAppeal = false
      } else if (this.mode == "cancelled") {
        this.isAppeal = false
      } else {
        this.isAppeal = false
      }
    },
    selectCategory() {
      this.form.subCategory = null;
      this.customerType = "customer"
      if (this.form.category == "other") {
        setTimeout(() => {
          this.form.subCategory = "other"
        }, 100)
      }
    },
    diffDays() {
      let days = 0;
      let minutes = 0;
      if (this.form.requestData.startDate && this.form.requestData.endDate) {
        minutes =
          this.$moment(this.form.requestData.endDate, "YYYY-MM-DD").diff(
            this.$moment(this.form.requestData.startDate, "YYYY-MM-DD"),
            "minutes"
          ) || 0;
        days = Math.ceil(minutes / (24 * 60)) + 1;
      }
      return days;
    },
    dayMonthYearText() {
      let days = 0;
      let months = 0;
      let years = 0;
      let text = "";
      if (this.form.requestData.startDate && this.form.requestData.endDate) {
        let a = this.$moment(this.form.requestData.endDate, "YYYY-MM-DD").endOf("day");
        let b = this.$moment(this.form.requestData.startDate, "YYYY-MM-DD").startOf("day");
        a.add(1, "days");
        years = a.diff(b, "year");
        b.add(years, "years");
        months = a.diff(b, "months");
        b.add(months, "months");
        days = a.diff(b, "days");
      }
      if (years) {
        text += `${years} ${this.$t('year')} `;
      }
      if (months) {
        text += `${months} ${this.$t('month')} `;
      }
      if (days) {
        text += `${days} ${this.$t('day')}`;
      }
      return text;
    },
    editSuspendDays(value) {
      let days = parseFloat(value);
      if (days && days > -1) {
        days--;
        let momentStartDate = this.$moment(this.form.requestData.startDate, "YYYY-MM-DD");
        momentStartDate.add(days, "days");
        this.form.requestData.endDate = momentStartDate.format("YYYY-MM-DD");
      }
    },
    editEndDate() {
      this.form.requestData.suspendDays = this.diffDays();
    },
    async getAllAreas() {
      this.currentAreas = [];
      if(!this.getAreas){
        await this.$store.dispatch("markets/getMarketArea", {
          id: this.marketId
        });
      }
      if(this.getAreas){
        for (let area of this.getAreas) {
          if (area.isOccupied || true) {
            if (!this.currentAreas) this.currentAreas = [];
            area.text = `${area.name || ""} 
            ${!area.contract?.isActive ? `(${this.$t('contract.close_rental_contract')})`
                : area.isOccupied
                  ? `(${this.$t('customer.in_rental_agreement')})`
                  : area.closeContractAt ? `(${this.$t('area.close_contract')})`
                    : `(${this.$t('customer.rental_agreement_expired')})`
              }`;
            this.currentAreas.push(area);
          }
        }
      }
    },
    onCustomerTypeChange(type) {
      this.customerType = type;
      if (type === 'central') {
        this.form.customer = null;
        this.form.customerId = '';
        this.form.areas = [];
        this.form.contract = null;
      }
    },
    removeImageUploadAll(type, errorId) {
      if (type == 'appeal_image') {
        this.images_tmp = [];
        if (errorId) {
          document.getElementById(errorId).style.display = "none";
          this.isMaxFileUploadAppealImage = false;
        }
      } else if (type == 'citizen_card') {
        this.citizenCardImages_tmp = [];
        if (errorId) {
          document.getElementById(errorId).style.display = "none";
          this.isMaxFileUploadCitizenCard = false;
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
.dialog-appeal.v-dialog .dialog-appeal-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}

.headline {
  display: flex;
  justify-content: space-between;
  padding: 25px 30px;
  background-color: #fff;

  .headline-filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .headline-text {
    font-size: 24px;
    font-weight: bolder;
  }
}

.filter-box {
  .filter-group {
    display: flex;
    align-items: baseline;
    gap: 15px;
    justify-content: flex-end;
  }

  .filter {
    width: 320px;
    max-width: 320px;
    min-width: auto;

    ::v-deep .v-input__slot {
      background-color: #ffffff !important;
    }
  }
}

.card-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  .v-card {
    width: 100%;
    min-width: 100%;
    overflow: visible;
  }

  .v-card:first-of-type {
    margin-top: 0;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  .card-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    z-index: 2;

    .number-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: #D44747;
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
    }
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}

.card-contant {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 0px;

  div {
    padding: 0px 5px;
  }
}

.card-tail {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 20px 5px;
}

.dialog-appeal-box {
  padding: 10px;
  border: 1px solid black;
}

.customer-box {
  min-height: 128px;
  width: 100%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 20;

  div {
    color: gray;
  }
}

.customer-box:hover {
  background: #ffffff;
}

.row {
  margin: unset;
}

.change-box {
  border: 1px solid rgba(128, 128, 128, 0.514);
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;

  .v-textarea {
    textarea {
      resize: horizontal;
    }
  }
}

.change-old-box {
  div {
    padding: 10px 15px;
    width: max-content;
    display: table-cell;
  }
}

.invoice-card {
  margin-top: 20px;
}

div.color-red {
  color: red;
  font-weight: lighter;
  font-size: small;
  letter-spacing: 0;
}

span.color-red {
  color: red;
  font-size: small;
  letter-spacing: 0;
}

span.danger-date {
  text-decoration: underline;
  margin-left: 5px;
}

div.danger-file {
  color: red;
  letter-spacing: 0;
  margin-left: 35px;
  display: none;
  font-size: 12px;
}

.row-installment .col {
  padding: 0 12px;
}

.product-in-areas-box-list {
  margin-bottom: 20px;

  .product-in-areas-box-header {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .product-in-areas-box {
    padding: 0px 15px;
    border: 1px solid rgba(128, 128, 128, 0.514);
    border-radius: 5px;

    .product-in-areas-items {
      margin: 15px 0;
      padding-bottom: 15px;
      border-bottom: 1px solid rgba(128, 128, 128, 0.514);

      .no-data {
        padding-left: 10px;
        margin-bottom: 5px;
      }
    }

    .product-in-areas-items:last-child {
      border-bottom: none;
      padding-bottom: 0px;
    }
  }
}

.renew-contract-box {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid rgb(211, 211, 211);
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 10px 15px;

  &.new {
    border: 2px solid #fbae43;
  }

  &.new-now {
    border: 2px solid var(--v-success-base);

  }

  .sub-title {
    font-size: 18px;
    padding-bottom: 0;
    display: flex;
    align-items: center;
  }

  .input-slot {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    border-radius: 4px;
    padding: 12px;
    margin: 0;
    font-size: 18px;
  }

  @for $i from 1 through 5 {
    $colum-size : 100% / ($i);

    .col-#{($i)} {
      width: $colum-size;
      max-width: $colum-size;
      flex-basis: $colum-size;
      min-width: 200px;
    }
  }
}

.text-description {
  font-size: 16px;
  color: #777777;
  padding: 0px 25px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  width: 100%;
  font-weight: 400;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.secondary_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  margin-bottom: 15px;
}

.status-box {
  display: flex;
  flex-direction: column;
  gap: 3px;

}

.loadmore-container {
  height: 100px;
  align-content: center;
  text-align: center;
  background-color: white;
  margin-top: 20px;

  .btn-loadmore {
    box-shadow: 0 0 0 0 !important;
    background-color: white;
  }
}


.box-radio {
  padding: 15px 10px;
  border: 1px solid #A9A9A9;
  border-radius: 8px;
  width: 100%;

  &.v-item--active {
    border: 1px solid var(--v-fontPrimary-base) !important;
    opacity: 1 !important;
    background: #E8F5E9 !important;
    color: #000 !important;

    ::v-deep .v-icon {
      color: var(--v-fontPrimary-base) !important;
    }
  }

  &.v-radio--is-disabled {
    border: 1px solid #A9A9A9;
    opacity: 1;
    cursor: not-allowed;
    pointer-events: none;
    background: #eee;
  }
}

.alert-warning-appeal {
  background-color: rgba(251, 174, 67, 0.1);
  color: #FBAE43;
}

.w-50 {
  width: 50%;
}

.text-description {
  font-size: 16px;
  color: #777777;
  padding: 0px 25px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  width: 100%;
  font-weight: 400;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.secondary_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  margin-bottom: 15px;
}

.status-box {
  display: flex;
  flex-direction: column;
  gap: 3px;

}

.loadmore-container {
  height: 100px;
  margin-left: -100%;
  margin-right: -100%;
  align-content: center;
  text-align: center;
  background-color: white;
  margin-top: 20px;
  margin-bottom: -20px;

  .btn-loadmore {
    box-shadow: 0 0 0 0 !important;
    background-color: white;
  }
}

.container-appeal-status {
  display: flex;
  gap: 15px;
  padding: 10px 20px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
.container-appeal-status:hover {
  -ms-overflow-style: thin;
  scrollbar-width:thin;
  &::-webkit-scrollbar {
    display:block;
  }
}


.filter-select {
  width: 320px;
  font-size: 16px;
  padding: 2px 10px !important;
  white-space: nowrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 200px;
  position: relative;
}

.filter-select-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 25px;
}

.filter-checkbox-item {
  padding: 0px !important;
  min-height: 40px !important;
}

.filter-checkbox::v-deep.v-input--selection-controls {
  padding: 0px 10px !important;
  margin: 0px !important;
}

.filter-select-count {
  position: absolute;
  right: 10px;
}
</style>